// Web CRM (Business plane) — FINAL localization pass dictionary (STATIC UI CHROME ONLY).
// Merged into the same flat per-language lookup as translations.js (same t() semantics).
// Scope: TicketManagement body, ShowroomManager edit labels, OverviewDashboard, ManageOperators,
// MarketplaceFeed chrome. NEVER used for dynamic/backend/user content (names, IDs, error.message,
// enum values). English is default + fallback. Keys are prefixed `fin.*`. 10 languages at parity.

const en = {
  'fin.common.quickActions': 'Quick Actions',
  'fin.tm.slaRules': 'SLA Rules',
  'fin.tm.automation': 'Automation',
  'fin.tm.reports': 'Reports',
  'fin.tm.slaRulesMgmt': 'SLA Rules Management',
  'fin.tm.slaRulesMgmtDesc': 'Configure Service Level Agreement rules and escalation policies',
  'fin.tm.addSlaRule': 'Add New SLA Rule',
  'fin.tm.ruleName': 'Rule Name *',
  'fin.tm.ruleNamePh1': 'e.g., High Priority Response',
  'fin.tm.priorityLevel': 'Priority Level',
  'fin.opt.low': 'Low',
  'fin.opt.medium': 'Medium',
  'fin.opt.high': 'High',
  'fin.opt.critical': 'Critical',
  'fin.tm.condition': 'Condition *',
  'fin.tm.conditionPh': 'e.g., Priority = High AND Customer Type = VIP',
  'fin.tm.action': 'Action *',
  'fin.tm.actionPh': 'e.g., Respond within 1 hour and escalate to Manager',
  'fin.tm.addSlaRuleBtn': 'Add SLA Rule',
  'fin.tm.activeSlaRules': 'Active SLA Rules',
  'fin.tm.active': 'Active',
  'fin.tm.inactive': 'Inactive',
  'fin.tm.when': 'When:',
  'fin.tm.then': 'Then:',
  'fin.tm.disable': 'Disable',
  'fin.tm.enable': 'Enable',
  'fin.tm.automationRules': 'Automation Rules',
  'fin.tm.automationRulesDesc': 'Configure automated actions for ticket processing and workflow',
  'fin.tm.addAutomationRule': 'Add New Automation Rule',
  'fin.tm.autoRuleNamePh': 'e.g., Auto-Assign Technical Issues',
  'fin.tm.triggerCondition': 'Trigger Condition *',
  'fin.tm.triggerConditionPh': 'e.g., Category = Technical AND Priority = High',
  'fin.tm.automatedAction': 'Automated Action *',
  'fin.tm.automatedActionPh': 'e.g., Assign to Technical Team and Send acknowledgment email',
  'fin.tm.addAutomationRuleBtn': 'Add Automation Rule',
  'fin.tm.activeAutomationRules': 'Active Automation Rules',
  'fin.tm.trigger': 'Trigger:',
  'fin.tm.actionLabel': 'Action:',
  'fin.tm.reportsTitle': 'Ticket Management Reports',
  'fin.tm.reportsDesc': 'Generate comprehensive reports for ticket analysis and performance tracking',
  'fin.tm.rptSlaPerf': 'SLA Performance',
  'fin.tm.rptSlaPerfSub': 'Response times & breaches',
  'fin.tm.rptAgentPerf': 'Agent Performance',
  'fin.tm.rptAgentPerfSub': 'Resolution rates & KPIs',
  'fin.tm.rptAutoEff': 'Automation Efficiency',
  'fin.tm.rptAutoEffSub': 'Rules performance',
  'fin.tm.rptCsat': 'Customer Satisfaction',
  'fin.tm.rptCsatSub': 'CSAT & feedback',
  'fin.tm.totalTickets': 'Total Tickets',
  'fin.tm.highPriority': 'High Priority',
  'fin.tm.slaAtRisk': 'SLA at Risk',
  'fin.tm.unassigned': 'Unassigned',
  'fin.tm.resolvedToday': 'Resolved Today',
  'fin.tm.searchPh': 'Search tickets...',
  'fin.tm.priority': 'Priority',
  'fin.tm.allPriority': 'All Priority',
  'fin.tm.status': 'Status',
  'fin.tm.allStatus': 'All Status',
  'fin.tm.resolved': 'Resolved',
  'fin.tm.inProgress': 'In Progress',
  'fin.tm.pending': 'Pending',
  'fin.tm.assignee': 'Assignee',
  'fin.tm.allAssignees': 'All Assignees',
  'fin.tm.apply': 'Apply',
  'fin.tm.applyTitle': 'Re-apply filters against the latest tickets',
  'fin.tm.sortTitle': 'Toggle sort by created date',
  'fin.tm.ticketsCount': 'Tickets ({count})',
  'fin.tm.newest': 'Newest',
  'fin.tm.oldest': 'Oldest',
  'fin.tm.loadErr': 'Failed to load tickets:',
  'fin.tm.noMatch': 'No tickets match the current filters.',
  'fin.tm.assignedTo': 'Assigned to:',
  'fin.tm.ticketDetails': 'Ticket Details',
  'fin.tm.customerInfo': 'Customer Information',
  'fin.tm.name': 'Name:',
  'fin.tm.tier': 'Tier:',
  'fin.tm.notConfigured': 'Not configured',
  'fin.tm.previousTickets': 'Previous Tickets:',
  'fin.tm.totalTicketsLbl': 'Total Tickets:',
  'fin.tm.satisfaction': 'Satisfaction:',
  'fin.tm.lastTicket': 'Last Ticket:',
  'fin.tm.slaManagement': 'SLA Management',
  'fin.tm.statusLbl': 'Status:',
  'fin.tm.timeRemaining': 'Time Remaining:',
  'fin.tm.deadlineLbl': 'Deadline:',
  'fin.tm.noSlaConfigured': 'No SLA configured for this ticket. Add an SLA rule (matching its priority) to enable a deadline.',
  'fin.tm.extendSla': 'Extend SLA',
  'fin.tm.assignment': 'Assignment',
  'fin.tm.escalationHistory': 'Escalation History',
  'fin.tm.level': 'Level',
  'fin.tm.escalateToManager': 'Escalate to Manager',
  'fin.tm.escalateTicket': 'Escalate Ticket',
  'fin.tm.escalateDesc': 'Escalate ticket #{id} to a manager',
  'fin.tm.selectManager': 'Select Manager *',
  'fin.tm.selectManagerPh': 'Select manager',
  'fin.tm.noManagers': 'No managers found',
  'fin.tm.urgencyLevel': 'Urgency Level',
  'fin.tm.urgLow': 'Low - Standard escalation',
  'fin.tm.urgNormal': 'Normal - Requires attention',
  'fin.tm.urgHigh': 'High - Urgent escalation',
  'fin.tm.urgCritical': 'Critical - Immediate attention',
  'fin.tm.escalationReason': 'Escalation Reason *',
  'fin.tm.escalationReasonPh': 'Explain why this ticket needs manager escalation...',
  'fin.tm.addInternalNote': 'Add Internal Note',
  'fin.tm.addNoteDesc': 'Add an internal note to ticket #{id}',
  'fin.tm.noteVisibility': 'Note Visibility',
  'fin.tm.visInternal': 'Internal Only - Staff can see',
  'fin.tm.visCustomer': 'Customer Visible - Include in updates',
  'fin.tm.noteContent': 'Note Content *',
  'fin.tm.noteContentPh': 'Enter your note here...',
  'fin.tm.addNote': 'Add Note',
  'fin.tm.setPriority': 'Set Priority',
  'fin.tm.setTicketPriority': 'Set Ticket Priority',
  'fin.tm.setPriorityDesc': 'Update priority for ticket #{id}',
  'fin.tm.prioLow': 'Low - Non-urgent issue',
  'fin.tm.prioMedium': 'Medium - Standard priority',
  'fin.tm.prioHigh': 'High - Important issue',
  'fin.tm.prioUrgent': 'Urgent - Critical issue',
  'fin.tm.reasonForChange': 'Reason for Change (Optional)',
  'fin.tm.reasonForChangePh': 'Explain why the priority is being changed...',
  'fin.tm.updatePriority': 'Update Priority',
  'fin.tm.reopenTicket': 'Reopen Ticket',
  'fin.tm.reopenPrompt': 'Reason for reopening (optional):',
  'fin.tm.markResolved': 'Mark as Resolved',
  'fin.tm.escalate': 'Escalate',
  'fin.tm.resolutionStepsRequired': 'Enter meaningful Resolution Steps (not empty, placeholder, a callback time, or a handoff) — they are required to resolve the ticket.',
  'fin.tm.resolutionStepsGovTitle': 'Resolution knowledge (required)',
  'fin.tm.resolutionStepsLabel': 'Resolution Steps (required)',
  'fin.tm.solutionSubmittedNote': 'Resolution submitted to the Solution Bank for manager/admin review.',
  'fin.tm.myQueue': 'My Queue',
  'fin.tm.escalatedBadge': 'Escalated',
  'fin.tm.selectOperator': 'Assign to operator',
  'fin.tm.selectOperatorPh': 'Select an available operator',
  'fin.tm.noOperators': 'No operators available',
  'fin.tm.assigneeRequired': 'Select an operator to assign',
  'fin.tm.knowledgeGovernanceHint': 'Reusable resolutions require meaningful steps and are reviewed by a manager or admin before AI reuse.',
  'fin.tm.resolveTicket': 'Resolve Ticket',
  'fin.tm.resolveDesc': 'Mark ticket #{id} as resolved',
  'fin.tm.resolutionSummary': 'Resolution Summary *',
  'fin.tm.resolutionSummaryPh': 'Describe how this issue was resolved...',
  'fin.tm.notifyCustomer': 'Notify customer of resolution',
  'fin.tm.submitToBank': 'Submit resolution to Solution Bank (pending approval)',
  'fin.tm.extendSlaDesc': 'Extend the SLA deadline for ticket #{id}. This is recorded with your name and reason.',
  'fin.tm.duration': 'Duration *',
  'fin.tm.durationPh': 'e.g. 4',
  'fin.tm.unit': 'Unit',
  'fin.tm.hours': 'Hours',
  'fin.tm.minutes': 'Minutes',
  'fin.tm.reason': 'Reason *',
  'fin.tm.reasonPh': 'Why is this SLA being extended?',
  'fin.tm.extending': 'Extending…',
  'fin.tm.quickResponse': 'Quick Response',
  'fin.tm.quickResponsePh': 'Type a message to the customer...',
  'fin.tm.sendToCustomer': 'Send to Customer',
  'fin.tm.selectTicket': 'Select a Ticket',
  'fin.tm.selectTicketDesc': 'Choose a ticket from the list to view details and manage assignment',
  'fin.tm.t.invalidDuration': 'Invalid duration',
  'fin.tm.t.enterPositive': 'Enter a positive number.',
  'fin.tm.t.reasonRequired': 'Reason required',
  'fin.tm.t.provideReasonExt': 'Please provide a reason for the extension.',
  'fin.tm.t.slaExtended': 'SLA Extended',
  'fin.tm.t.slaExtendedDesc': 'New deadline: {deadline}.',
  'fin.tm.t.updated': 'updated',
  'fin.tm.t.extendFailed': 'Extend Failed',
  'fin.tm.t.networkError': 'Network error',
  'fin.tm.t.missingInfo': 'Missing Information',
  'fin.tm.t.fillRequired': 'Please fill in all required fields',
  'fin.tm.t.slaRuleSaved': 'SLA Rule Saved',
  'fin.tm.t.ruleSavedDesc': 'Rule "{name}" saved to backend.',
  'fin.tm.t.saveFailed': 'Save Failed',
  'fin.tm.t.updateFailed': 'Update Failed',
  'fin.tm.t.automationRuleSaved': 'Automation Rule Saved',
  'fin.tm.t.reportDownloaded': 'Report Downloaded',
  'fin.tm.t.reportDownloadedDesc': '{report} report generated from live data.',
  'fin.tm.t.reportFailed': 'Report Failed',
  'fin.tm.t.reasonRequired2': 'Reason Required',
  'fin.tm.t.provideEscReason': 'Please provide an escalation reason.',
  'fin.tm.t.escalated': 'Escalated',
  'fin.tm.t.escalatedDesc': 'Escalation record created. ID: {id}',
  'fin.tm.t.escalationFailed': 'Escalation Failed',
  'fin.tm.t.failedEscalate': 'Failed to escalate.',
  'fin.tm.t.noteRequired': 'Note Required',
  'fin.tm.t.enterNote': 'Please enter a note before saving.',
  'fin.tm.t.noteAdded': 'Note Added',
  'fin.tm.t.noteAddedDesc': 'Note saved to conversation {conv}.',
  'fin.tm.t.failedAddNote': 'Failed to Add Note',
  'fin.tm.t.failedSaveNote': 'Failed to save note.',
  'fin.tm.t.priorityUpdated': 'Priority Updated',
  'fin.tm.t.priorityUpdatedDesc': 'Ticket {ticket} priority set to {priority}.',
  'fin.tm.t.priorityUpdateFailed': 'Priority Update Failed',
  'fin.tm.t.resolutionRequired': 'Resolution Required',
  'fin.tm.t.provideResolution': 'Please provide a resolution summary.',
  'fin.tm.t.ticketResolved': 'Ticket Resolved',
  'fin.tm.t.ticketResolvedDesc': 'Ticket {ticket} resolved and persisted.',
  'fin.tm.t.solutionSubmitted': ' Solution submitted for approval (ID: {id}).',
  'fin.tm.t.resolutionFailed': 'Resolution Failed',
  'fin.tm.t.failedResolve': 'Failed to resolve ticket.',
  'fin.tm.t.ticketReopened': 'Ticket Reopened',
  'fin.tm.t.ticketReopenedDesc': 'Ticket {ticket} has been reopened and returned to queue.',
  'fin.tm.t.reopenFailed': 'Reopen Failed',
  'fin.tm.t.failedReopen': 'Failed to reopen ticket.',
  'fin.tm.t.assigned': 'Assigned',
  'fin.tm.t.assignedDesc': 'Ticket {ticket} assigned to staff {staff}.',
  'fin.tm.t.assignmentFailed': 'Assignment Failed',
  'fin.tm.t.noConversation': 'No Conversation',
  'fin.tm.t.cannotSend': 'Cannot send — no conversation linked to this ticket.',
  'fin.tm.t.messageSent': 'Message Sent',
  'fin.tm.t.messageSentDesc': 'Customer will receive this message.',
  'fin.tm.t.sendFailed': 'Send Failed',
  'fin.tm.t.failedSend': 'Failed to send message.',
  'fin.sm.businessName': 'Business Name',
  'fin.sm.description': 'Description',
  'fin.sm.address': 'Address',
  'fin.ov.aiVoicePerf': 'AI Voice Agent Performance',
  'fin.mo.refreshMetrics': 'Refresh metrics',
  'fin.mf.noRatings': 'No ratings yet',
  'fin.mf.marketplaceError': 'Marketplace Error:',
  'fin.mf.somethingWrong': 'Something went wrong. Please try again.',
  'fin.mf.enterLocation': 'Enter location',
  'fin.mf.includesVideo': 'Includes video',
  'fin.mf.viewDetails': 'View details',
  'fin.preview.publicProfilePreview': 'Public Profile Preview',
  'fin.preview.showroomFallback': 'Showroom',
  'fin.preview.businessShowroom': 'Business Showroom',
  'fin.preview.businessId': 'Business ID:',
  'fin.preview.about': 'About',
  'fin.preview.noDescription': 'No description available',
  'fin.preview.contactInfo': 'Contact Information',
  'fin.preview.email': 'Email:',
  'fin.preview.phone': 'Phone:',
  'fin.preview.location': 'Location:',
  'fin.preview.notProvided': 'Not provided',
  'fin.preview.chatAvailable': 'Chat Available:',
  'fin.preview.inAppCalls': 'In-App Calls:',
  'fin.preview.productsServices': 'Products & Services',
  'fin.preview.items': 'items',
  'fin.preview.price': 'Price:',
  'fin.preview.category': 'Category:',
  'fin.preview.noImages': 'No images',
  'fin.preview.noProducts': 'No products available at this time.',
  'fin.preview.productsWillAppear': 'Products will appear here once you add them to your showroom.',
  'fin.preview.footer': 'This is a preview of your public showroom profile as it would appear to customers.',
};

const es = {
  'fin.common.quickActions': 'Acciones rápidas',
  'fin.tm.slaRules': 'Reglas de SLA',
  'fin.tm.automation': 'Automatización',
  'fin.tm.reports': 'Informes',
  'fin.tm.slaRulesMgmt': 'Gestión de reglas de SLA',
  'fin.tm.slaRulesMgmtDesc': 'Configure las reglas de acuerdo de nivel de servicio y las políticas de escalado',
  'fin.tm.addSlaRule': 'Añadir nueva regla de SLA',
  'fin.tm.ruleName': 'Nombre de la regla *',
  'fin.tm.ruleNamePh1': 'p. ej., Respuesta de alta prioridad',
  'fin.tm.priorityLevel': 'Nivel de prioridad',
  'fin.opt.low': 'Baja',
  'fin.opt.medium': 'Media',
  'fin.opt.high': 'Alta',
  'fin.opt.critical': 'Crítica',
  'fin.tm.condition': 'Condición *',
  'fin.tm.conditionPh': 'p. ej., Prioridad = Alta Y Tipo de cliente = VIP',
  'fin.tm.action': 'Acción *',
  'fin.tm.actionPh': 'p. ej., Responder en 1 hora y escalar al gerente',
  'fin.tm.addSlaRuleBtn': 'Añadir regla de SLA',
  'fin.tm.activeSlaRules': 'Reglas de SLA activas',
  'fin.tm.active': 'Activa',
  'fin.tm.inactive': 'Inactiva',
  'fin.tm.when': 'Cuándo:',
  'fin.tm.then': 'Entonces:',
  'fin.tm.disable': 'Desactivar',
  'fin.tm.enable': 'Activar',
  'fin.tm.automationRules': 'Reglas de automatización',
  'fin.tm.automationRulesDesc': 'Configure acciones automatizadas para el procesamiento y el flujo de trabajo de tickets',
  'fin.tm.addAutomationRule': 'Añadir nueva regla de automatización',
  'fin.tm.autoRuleNamePh': 'p. ej., Asignar automáticamente problemas técnicos',
  'fin.tm.triggerCondition': 'Condición desencadenante *',
  'fin.tm.triggerConditionPh': 'p. ej., Categoría = Técnica Y Prioridad = Alta',
  'fin.tm.automatedAction': 'Acción automatizada *',
  'fin.tm.automatedActionPh': 'p. ej., Asignar al equipo técnico y enviar correo de confirmación',
  'fin.tm.addAutomationRuleBtn': 'Añadir regla de automatización',
  'fin.tm.activeAutomationRules': 'Reglas de automatización activas',
  'fin.tm.trigger': 'Desencadenante:',
  'fin.tm.actionLabel': 'Acción:',
  'fin.tm.reportsTitle': 'Informes de gestión de tickets',
  'fin.tm.reportsDesc': 'Genere informes completos para el análisis de tickets y el seguimiento del rendimiento',
  'fin.tm.rptSlaPerf': 'Rendimiento de SLA',
  'fin.tm.rptSlaPerfSub': 'Tiempos de respuesta e incumplimientos',
  'fin.tm.rptAgentPerf': 'Rendimiento del agente',
  'fin.tm.rptAgentPerfSub': 'Tasas de resolución y KPI',
  'fin.tm.rptAutoEff': 'Eficiencia de la automatización',
  'fin.tm.rptAutoEffSub': 'Rendimiento de las reglas',
  'fin.tm.rptCsat': 'Satisfacción del cliente',
  'fin.tm.rptCsatSub': 'CSAT y comentarios',
  'fin.tm.totalTickets': 'Tickets totales',
  'fin.tm.highPriority': 'Alta prioridad',
  'fin.tm.slaAtRisk': 'SLA en riesgo',
  'fin.tm.unassigned': 'Sin asignar',
  'fin.tm.resolvedToday': 'Resueltos hoy',
  'fin.tm.searchPh': 'Buscar tickets...',
  'fin.tm.priority': 'Prioridad',
  'fin.tm.allPriority': 'Todas las prioridades',
  'fin.tm.status': 'Estado',
  'fin.tm.allStatus': 'Todos los estados',
  'fin.tm.resolved': 'Resuelto',
  'fin.tm.inProgress': 'En curso',
  'fin.tm.pending': 'Pendiente',
  'fin.tm.assignee': 'Asignado a',
  'fin.tm.allAssignees': 'Todos los asignados',
  'fin.tm.apply': 'Aplicar',
  'fin.tm.applyTitle': 'Volver a aplicar los filtros a los tickets más recientes',
  'fin.tm.sortTitle': 'Alternar el orden por fecha de creación',
  'fin.tm.ticketsCount': 'Tickets ({count})',
  'fin.tm.newest': 'Más recientes',
  'fin.tm.oldest': 'Más antiguos',
  'fin.tm.loadErr': 'Error al cargar los tickets:',
  'fin.tm.noMatch': 'Ningún ticket coincide con los filtros actuales.',
  'fin.tm.assignedTo': 'Asignado a:',
  'fin.tm.ticketDetails': 'Detalles del ticket',
  'fin.tm.customerInfo': 'Información del cliente',
  'fin.tm.name': 'Nombre:',
  'fin.tm.tier': 'Nivel:',
  'fin.tm.notConfigured': 'No configurado',
  'fin.tm.previousTickets': 'Tickets anteriores:',
  'fin.tm.totalTicketsLbl': 'Tickets totales:',
  'fin.tm.satisfaction': 'Satisfacción:',
  'fin.tm.lastTicket': 'Último ticket:',
  'fin.tm.slaManagement': 'Gestión de SLA',
  'fin.tm.statusLbl': 'Estado:',
  'fin.tm.timeRemaining': 'Tiempo restante:',
  'fin.tm.deadlineLbl': 'Fecha límite:',
  'fin.tm.noSlaConfigured': 'No hay SLA configurado para este ticket. Añada una regla de SLA (que coincida con su prioridad) para habilitar una fecha límite.',
  'fin.tm.extendSla': 'Ampliar SLA',
  'fin.tm.assignment': 'Asignación',
  'fin.tm.escalationHistory': 'Historial de escalado',
  'fin.tm.level': 'Nivel',
  'fin.tm.escalateToManager': 'Escalar al gerente',
  'fin.tm.escalateTicket': 'Escalar ticket',
  'fin.tm.escalateDesc': 'Escalar el ticket n.º {id} a un gerente',
  'fin.tm.selectManager': 'Seleccionar gerente *',
  'fin.tm.selectManagerPh': 'Seleccionar gerente',
  'fin.tm.noManagers': 'No se encontraron gerentes',
  'fin.tm.urgencyLevel': 'Nivel de urgencia',
  'fin.tm.urgLow': 'Baja - Escalado estándar',
  'fin.tm.urgNormal': 'Normal - Requiere atención',
  'fin.tm.urgHigh': 'Alta - Escalado urgente',
  'fin.tm.urgCritical': 'Crítica - Atención inmediata',
  'fin.tm.escalationReason': 'Motivo del escalado *',
  'fin.tm.escalationReasonPh': 'Explique por qué este ticket necesita ser escalado al gerente...',
  'fin.tm.addInternalNote': 'Añadir nota interna',
  'fin.tm.addNoteDesc': 'Añadir una nota interna al ticket n.º {id}',
  'fin.tm.noteVisibility': 'Visibilidad de la nota',
  'fin.tm.visInternal': 'Solo interno - El personal puede verla',
  'fin.tm.visCustomer': 'Visible para el cliente - Incluir en actualizaciones',
  'fin.tm.noteContent': 'Contenido de la nota *',
  'fin.tm.noteContentPh': 'Escriba su nota aquí...',
  'fin.tm.addNote': 'Añadir nota',
  'fin.tm.setPriority': 'Establecer prioridad',
  'fin.tm.setTicketPriority': 'Establecer prioridad del ticket',
  'fin.tm.setPriorityDesc': 'Actualizar la prioridad del ticket n.º {id}',
  'fin.tm.prioLow': 'Baja - Problema no urgente',
  'fin.tm.prioMedium': 'Media - Prioridad estándar',
  'fin.tm.prioHigh': 'Alta - Problema importante',
  'fin.tm.prioUrgent': 'Urgente - Problema crítico',
  'fin.tm.reasonForChange': 'Motivo del cambio (opcional)',
  'fin.tm.reasonForChangePh': 'Explique por qué se cambia la prioridad...',
  'fin.tm.updatePriority': 'Actualizar prioridad',
  'fin.tm.reopenTicket': 'Reabrir ticket',
  'fin.tm.reopenPrompt': 'Motivo de la reapertura (opcional):',
  'fin.tm.markResolved': 'Marcar como resuelto',
  'fin.tm.escalate': 'Escalar',
  'fin.tm.resolutionStepsRequired': 'Ingrese pasos de resolución significativos (no vacíos, ni de marcador, ni una hora de devolución de llamada, ni una transferencia): son obligatorios para resolver el ticket.',
  'fin.tm.resolutionStepsGovTitle': 'Conocimiento de resolución (obligatorio)',
  'fin.tm.resolutionStepsLabel': 'Pasos de resolución (obligatorio)',
  'fin.tm.solutionSubmittedNote': 'Resolución enviada al Banco de soluciones para revisión de gerente/administrador.',
  'fin.tm.myQueue': 'Mi cola',
  'fin.tm.escalatedBadge': 'Escalado',
  'fin.tm.selectOperator': 'Asignar a operador',
  'fin.tm.selectOperatorPh': 'Seleccione un operador disponible',
  'fin.tm.noOperators': 'No hay operadores disponibles',
  'fin.tm.assigneeRequired': 'Seleccione un operador para asignar',
  'fin.tm.knowledgeGovernanceHint': 'Las resoluciones reutilizables requieren pasos significativos y son revisadas por un gerente o administrador antes de su reutilización por la IA.',
  'fin.tm.resolveTicket': 'Resolver ticket',
  'fin.tm.resolveDesc': 'Marcar el ticket n.º {id} como resuelto',
  'fin.tm.resolutionSummary': 'Resumen de la resolución *',
  'fin.tm.resolutionSummaryPh': 'Describa cómo se resolvió este problema...',
  'fin.tm.notifyCustomer': 'Notificar al cliente de la resolución',
  'fin.tm.submitToBank': 'Enviar la resolución al Banco de soluciones (pendiente de aprobación)',
  'fin.tm.extendSlaDesc': 'Ampliar la fecha límite del SLA para el ticket n.º {id}. Esto se registra con su nombre y motivo.',
  'fin.tm.duration': 'Duración *',
  'fin.tm.durationPh': 'p. ej. 4',
  'fin.tm.unit': 'Unidad',
  'fin.tm.hours': 'Horas',
  'fin.tm.minutes': 'Minutos',
  'fin.tm.reason': 'Motivo *',
  'fin.tm.reasonPh': '¿Por qué se amplía este SLA?',
  'fin.tm.extending': 'Ampliando…',
  'fin.tm.quickResponse': 'Respuesta rápida',
  'fin.tm.quickResponsePh': 'Escriba un mensaje para el cliente...',
  'fin.tm.sendToCustomer': 'Enviar al cliente',
  'fin.tm.selectTicket': 'Seleccione un ticket',
  'fin.tm.selectTicketDesc': 'Elija un ticket de la lista para ver los detalles y gestionar la asignación',
  'fin.tm.t.invalidDuration': 'Duración no válida',
  'fin.tm.t.enterPositive': 'Introduzca un número positivo.',
  'fin.tm.t.reasonRequired': 'Se requiere un motivo',
  'fin.tm.t.provideReasonExt': 'Proporcione un motivo para la ampliación.',
  'fin.tm.t.slaExtended': 'SLA ampliado',
  'fin.tm.t.slaExtendedDesc': 'Nueva fecha límite: {deadline}.',
  'fin.tm.t.updated': 'actualizada',
  'fin.tm.t.extendFailed': 'Error al ampliar',
  'fin.tm.t.networkError': 'Error de red',
  'fin.tm.t.missingInfo': 'Falta información',
  'fin.tm.t.fillRequired': 'Complete todos los campos obligatorios',
  'fin.tm.t.slaRuleSaved': 'Regla de SLA guardada',
  'fin.tm.t.ruleSavedDesc': 'Regla "{name}" guardada en el servidor.',
  'fin.tm.t.saveFailed': 'Error al guardar',
  'fin.tm.t.updateFailed': 'Error al actualizar',
  'fin.tm.t.automationRuleSaved': 'Regla de automatización guardada',
  'fin.tm.t.reportDownloaded': 'Informe descargado',
  'fin.tm.t.reportDownloadedDesc': 'Informe de {report} generado a partir de datos en vivo.',
  'fin.tm.t.reportFailed': 'Error del informe',
  'fin.tm.t.reasonRequired2': 'Motivo requerido',
  'fin.tm.t.provideEscReason': 'Proporcione un motivo para el escalado.',
  'fin.tm.t.escalated': 'Escalado',
  'fin.tm.t.escalatedDesc': 'Registro de escalado creado. ID: {id}',
  'fin.tm.t.escalationFailed': 'Error al escalar',
  'fin.tm.t.failedEscalate': 'No se pudo escalar.',
  'fin.tm.t.noteRequired': 'Se requiere una nota',
  'fin.tm.t.enterNote': 'Introduzca una nota antes de guardar.',
  'fin.tm.t.noteAdded': 'Nota añadida',
  'fin.tm.t.noteAddedDesc': 'Nota guardada en la conversación {conv}.',
  'fin.tm.t.failedAddNote': 'Error al añadir la nota',
  'fin.tm.t.failedSaveNote': 'No se pudo guardar la nota.',
  'fin.tm.t.priorityUpdated': 'Prioridad actualizada',
  'fin.tm.t.priorityUpdatedDesc': 'Prioridad del ticket {ticket} establecida en {priority}.',
  'fin.tm.t.priorityUpdateFailed': 'Error al actualizar la prioridad',
  'fin.tm.t.resolutionRequired': 'Se requiere una resolución',
  'fin.tm.t.provideResolution': 'Proporcione un resumen de la resolución.',
  'fin.tm.t.ticketResolved': 'Ticket resuelto',
  'fin.tm.t.ticketResolvedDesc': 'Ticket {ticket} resuelto y guardado.',
  'fin.tm.t.solutionSubmitted': ' Solución enviada para aprobación (ID: {id}).',
  'fin.tm.t.resolutionFailed': 'Error en la resolución',
  'fin.tm.t.failedResolve': 'No se pudo resolver el ticket.',
  'fin.tm.t.ticketReopened': 'Ticket reabierto',
  'fin.tm.t.ticketReopenedDesc': 'El ticket {ticket} se ha reabierto y devuelto a la cola.',
  'fin.tm.t.reopenFailed': 'Error al reabrir',
  'fin.tm.t.failedReopen': 'No se pudo reabrir el ticket.',
  'fin.tm.t.assigned': 'Asignado',
  'fin.tm.t.assignedDesc': 'Ticket {ticket} asignado al personal {staff}.',
  'fin.tm.t.assignmentFailed': 'Error en la asignación',
  'fin.tm.t.noConversation': 'Sin conversación',
  'fin.tm.t.cannotSend': 'No se puede enviar: no hay ninguna conversación vinculada a este ticket.',
  'fin.tm.t.messageSent': 'Mensaje enviado',
  'fin.tm.t.messageSentDesc': 'El cliente recibirá este mensaje.',
  'fin.tm.t.sendFailed': 'Error al enviar',
  'fin.tm.t.failedSend': 'No se pudo enviar el mensaje.',
  'fin.sm.businessName': 'Nombre de la empresa',
  'fin.sm.description': 'Descripción',
  'fin.sm.address': 'Dirección',
  'fin.ov.aiVoicePerf': 'Rendimiento del agente de voz IA',
  'fin.mo.refreshMetrics': 'Actualizar métricas',
  'fin.mf.noRatings': 'Aún no hay valoraciones',
  'fin.mf.marketplaceError': 'Error del mercado:',
  'fin.mf.somethingWrong': 'Algo salió mal. Inténtelo de nuevo.',
  'fin.mf.enterLocation': 'Introduzca la ubicación',
  'fin.mf.includesVideo': 'Incluye vídeo',
  'fin.mf.viewDetails': 'Ver detalles',
  'fin.preview.publicProfilePreview': 'Vista previa del perfil público',
  'fin.preview.showroomFallback': 'Sala de exposición',
  'fin.preview.businessShowroom': 'Sala de exposición de la empresa',
  'fin.preview.businessId': 'ID de la empresa:',
  'fin.preview.about': 'Acerca de',
  'fin.preview.noDescription': 'No hay descripción disponible',
  'fin.preview.contactInfo': 'Información de contacto',
  'fin.preview.email': 'Correo electrónico:',
  'fin.preview.phone': 'Teléfono:',
  'fin.preview.location': 'Ubicación:',
  'fin.preview.notProvided': 'No proporcionado',
  'fin.preview.chatAvailable': 'Chat disponible:',
  'fin.preview.inAppCalls': 'Llamadas en la app:',
  'fin.preview.productsServices': 'Productos y servicios',
  'fin.preview.items': 'artículos',
  'fin.preview.price': 'Precio:',
  'fin.preview.category': 'Categoría:',
  'fin.preview.noImages': 'Sin imágenes',
  'fin.preview.noProducts': 'No hay productos disponibles en este momento.',
  'fin.preview.productsWillAppear': 'Los productos aparecerán aquí una vez que los añada a su sala de exposición.',
  'fin.preview.footer': 'Esta es una vista previa del perfil público de su sala de exposición tal como lo verían los clientes.',
};
const fr = {
  'fin.common.quickActions': 'Actions rapides',
  'fin.tm.slaRules': 'Règles de SLA',
  'fin.tm.automation': 'Automatisation',
  'fin.tm.reports': 'Rapports',
  'fin.tm.slaRulesMgmt': 'Gestion des règles de SLA',
  'fin.tm.slaRulesMgmtDesc': 'Configurez les règles de contrat de niveau de service et les politiques d\'escalade',
  'fin.tm.addSlaRule': 'Ajouter une nouvelle règle de SLA',
  'fin.tm.ruleName': 'Nom de la règle *',
  'fin.tm.ruleNamePh1': 'p. ex., Réponse haute priorité',
  'fin.tm.priorityLevel': 'Niveau de priorité',
  'fin.opt.low': 'Faible',
  'fin.opt.medium': 'Moyenne',
  'fin.opt.high': 'Élevée',
  'fin.opt.critical': 'Critique',
  'fin.tm.condition': 'Condition *',
  'fin.tm.conditionPh': 'p. ex., Priorité = Élevée ET Type de client = VIP',
  'fin.tm.action': 'Action *',
  'fin.tm.actionPh': 'p. ex., Répondre sous 1 heure et escalader au responsable',
  'fin.tm.addSlaRuleBtn': 'Ajouter une règle de SLA',
  'fin.tm.activeSlaRules': 'Règles de SLA actives',
  'fin.tm.active': 'Active',
  'fin.tm.inactive': 'Inactive',
  'fin.tm.when': 'Quand :',
  'fin.tm.then': 'Alors :',
  'fin.tm.disable': 'Désactiver',
  'fin.tm.enable': 'Activer',
  'fin.tm.automationRules': 'Règles d\'automatisation',
  'fin.tm.automationRulesDesc': 'Configurez des actions automatisées pour le traitement et le flux de travail des tickets',
  'fin.tm.addAutomationRule': 'Ajouter une nouvelle règle d\'automatisation',
  'fin.tm.autoRuleNamePh': 'p. ex., Attribuer automatiquement les problèmes techniques',
  'fin.tm.triggerCondition': 'Condition de déclenchement *',
  'fin.tm.triggerConditionPh': 'p. ex., Catégorie = Technique ET Priorité = Élevée',
  'fin.tm.automatedAction': 'Action automatisée *',
  'fin.tm.automatedActionPh': 'p. ex., Attribuer à l\'équipe technique et envoyer un e-mail de confirmation',
  'fin.tm.addAutomationRuleBtn': 'Ajouter une règle d\'automatisation',
  'fin.tm.activeAutomationRules': 'Règles d\'automatisation actives',
  'fin.tm.trigger': 'Déclencheur :',
  'fin.tm.actionLabel': 'Action :',
  'fin.tm.reportsTitle': 'Rapports de gestion des tickets',
  'fin.tm.reportsDesc': 'Générez des rapports complets pour l\'analyse des tickets et le suivi des performances',
  'fin.tm.rptSlaPerf': 'Performance du SLA',
  'fin.tm.rptSlaPerfSub': 'Temps de réponse et manquements',
  'fin.tm.rptAgentPerf': 'Performance de l\'agent',
  'fin.tm.rptAgentPerfSub': 'Taux de résolution et KPI',
  'fin.tm.rptAutoEff': 'Efficacité de l\'automatisation',
  'fin.tm.rptAutoEffSub': 'Performance des règles',
  'fin.tm.rptCsat': 'Satisfaction client',
  'fin.tm.rptCsatSub': 'CSAT et commentaires',
  'fin.tm.totalTickets': 'Total des tickets',
  'fin.tm.highPriority': 'Haute priorité',
  'fin.tm.slaAtRisk': 'SLA à risque',
  'fin.tm.unassigned': 'Non attribué',
  'fin.tm.resolvedToday': 'Résolus aujourd\'hui',
  'fin.tm.searchPh': 'Rechercher des tickets...',
  'fin.tm.priority': 'Priorité',
  'fin.tm.allPriority': 'Toutes les priorités',
  'fin.tm.status': 'Statut',
  'fin.tm.allStatus': 'Tous les statuts',
  'fin.tm.resolved': 'Résolu',
  'fin.tm.inProgress': 'En cours',
  'fin.tm.pending': 'En attente',
  'fin.tm.assignee': 'Attribué à',
  'fin.tm.allAssignees': 'Tous les responsables',
  'fin.tm.apply': 'Appliquer',
  'fin.tm.applyTitle': 'Réappliquer les filtres aux tickets les plus récents',
  'fin.tm.sortTitle': 'Basculer le tri par date de création',
  'fin.tm.ticketsCount': 'Tickets ({count})',
  'fin.tm.newest': 'Plus récents',
  'fin.tm.oldest': 'Plus anciens',
  'fin.tm.loadErr': 'Échec du chargement des tickets :',
  'fin.tm.noMatch': 'Aucun ticket ne correspond aux filtres actuels.',
  'fin.tm.assignedTo': 'Attribué à :',
  'fin.tm.ticketDetails': 'Détails du ticket',
  'fin.tm.customerInfo': 'Informations sur le client',
  'fin.tm.name': 'Nom :',
  'fin.tm.tier': 'Niveau :',
  'fin.tm.notConfigured': 'Non configuré',
  'fin.tm.previousTickets': 'Tickets précédents :',
  'fin.tm.totalTicketsLbl': 'Total des tickets :',
  'fin.tm.satisfaction': 'Satisfaction :',
  'fin.tm.lastTicket': 'Dernier ticket :',
  'fin.tm.slaManagement': 'Gestion du SLA',
  'fin.tm.statusLbl': 'Statut :',
  'fin.tm.timeRemaining': 'Temps restant :',
  'fin.tm.deadlineLbl': 'Échéance :',
  'fin.tm.noSlaConfigured': 'Aucun SLA configuré pour ce ticket. Ajoutez une règle de SLA (correspondant à sa priorité) pour activer une échéance.',
  'fin.tm.extendSla': 'Prolonger le SLA',
  'fin.tm.assignment': 'Attribution',
  'fin.tm.escalationHistory': 'Historique des escalades',
  'fin.tm.level': 'Niveau',
  'fin.tm.escalateToManager': 'Escalader au responsable',
  'fin.tm.escalateTicket': 'Escalader le ticket',
  'fin.tm.escalateDesc': 'Escalader le ticket n° {id} à un responsable',
  'fin.tm.selectManager': 'Sélectionner un responsable *',
  'fin.tm.selectManagerPh': 'Sélectionner un responsable',
  'fin.tm.noManagers': 'Aucun responsable trouvé',
  'fin.tm.urgencyLevel': 'Niveau d\'urgence',
  'fin.tm.urgLow': 'Faible - Escalade standard',
  'fin.tm.urgNormal': 'Normale - Nécessite une attention',
  'fin.tm.urgHigh': 'Élevée - Escalade urgente',
  'fin.tm.urgCritical': 'Critique - Attention immédiate',
  'fin.tm.escalationReason': 'Motif de l\'escalade *',
  'fin.tm.escalationReasonPh': 'Expliquez pourquoi ce ticket doit être escaladé au responsable...',
  'fin.tm.addInternalNote': 'Ajouter une note interne',
  'fin.tm.addNoteDesc': 'Ajouter une note interne au ticket n° {id}',
  'fin.tm.noteVisibility': 'Visibilité de la note',
  'fin.tm.visInternal': 'Interne uniquement - Visible par le personnel',
  'fin.tm.visCustomer': 'Visible par le client - Inclure dans les mises à jour',
  'fin.tm.noteContent': 'Contenu de la note *',
  'fin.tm.noteContentPh': 'Saisissez votre note ici...',
  'fin.tm.addNote': 'Ajouter une note',
  'fin.tm.setPriority': 'Définir la priorité',
  'fin.tm.setTicketPriority': 'Définir la priorité du ticket',
  'fin.tm.setPriorityDesc': 'Mettre à jour la priorité du ticket n° {id}',
  'fin.tm.prioLow': 'Faible - Problème non urgent',
  'fin.tm.prioMedium': 'Moyenne - Priorité standard',
  'fin.tm.prioHigh': 'Élevée - Problème important',
  'fin.tm.prioUrgent': 'Urgente - Problème critique',
  'fin.tm.reasonForChange': 'Motif du changement (facultatif)',
  'fin.tm.reasonForChangePh': 'Expliquez pourquoi la priorité est modifiée...',
  'fin.tm.updatePriority': 'Mettre à jour la priorité',
  'fin.tm.reopenTicket': 'Rouvrir le ticket',
  'fin.tm.reopenPrompt': 'Motif de la réouverture (facultatif) :',
  'fin.tm.markResolved': 'Marquer comme résolu',
  'fin.tm.escalate': 'Escalader',
  'fin.tm.resolutionStepsRequired': 'Saisissez des étapes de résolution concrètes (ni vides, ni fictives, ni une heure de rappel, ni un transfert) — elles sont obligatoires pour résoudre le ticket.',
  'fin.tm.resolutionStepsGovTitle': 'Connaissance de résolution (obligatoire)',
  'fin.tm.resolutionStepsLabel': 'Étapes de résolution (obligatoire)',
  'fin.tm.solutionSubmittedNote': 'Résolution soumise à la Banque de solutions pour revue responsable/administrateur.',
  'fin.tm.myQueue': 'Ma file',
  'fin.tm.escalatedBadge': 'Escaladé',
  'fin.tm.selectOperator': 'Attribuer à un opérateur',
  'fin.tm.selectOperatorPh': 'Sélectionnez un opérateur disponible',
  'fin.tm.noOperators': 'Aucun opérateur disponible',
  'fin.tm.assigneeRequired': 'Sélectionnez un opérateur à qui attribuer',
  'fin.tm.knowledgeGovernanceHint': 'Les résolutions réutilisables nécessitent des étapes concrètes et sont examinées par un responsable ou un administrateur avant leur réutilisation par l’IA.',
  'fin.tm.resolveTicket': 'Résoudre le ticket',
  'fin.tm.resolveDesc': 'Marquer le ticket n° {id} comme résolu',
  'fin.tm.resolutionSummary': 'Résumé de la résolution *',
  'fin.tm.resolutionSummaryPh': 'Décrivez comment ce problème a été résolu...',
  'fin.tm.notifyCustomer': 'Informer le client de la résolution',
  'fin.tm.submitToBank': 'Soumettre la résolution à la Banque de solutions (en attente d\'approbation)',
  'fin.tm.extendSlaDesc': 'Prolonger l\'échéance du SLA pour le ticket n° {id}. Ceci est enregistré avec votre nom et votre motif.',
  'fin.tm.duration': 'Durée *',
  'fin.tm.durationPh': 'p. ex. 4',
  'fin.tm.unit': 'Unité',
  'fin.tm.hours': 'Heures',
  'fin.tm.minutes': 'Minutes',
  'fin.tm.reason': 'Motif *',
  'fin.tm.reasonPh': 'Pourquoi ce SLA est-il prolongé ?',
  'fin.tm.extending': 'Prolongation…',
  'fin.tm.quickResponse': 'Réponse rapide',
  'fin.tm.quickResponsePh': 'Saisissez un message pour le client...',
  'fin.tm.sendToCustomer': 'Envoyer au client',
  'fin.tm.selectTicket': 'Sélectionnez un ticket',
  'fin.tm.selectTicketDesc': 'Choisissez un ticket dans la liste pour voir les détails et gérer l\'attribution',
  'fin.tm.t.invalidDuration': 'Durée non valide',
  'fin.tm.t.enterPositive': 'Saisissez un nombre positif.',
  'fin.tm.t.reasonRequired': 'Motif requis',
  'fin.tm.t.provideReasonExt': 'Veuillez indiquer un motif pour la prolongation.',
  'fin.tm.t.slaExtended': 'SLA prolongé',
  'fin.tm.t.slaExtendedDesc': 'Nouvelle échéance : {deadline}.',
  'fin.tm.t.updated': 'mise à jour',
  'fin.tm.t.extendFailed': 'Échec de la prolongation',
  'fin.tm.t.networkError': 'Erreur réseau',
  'fin.tm.t.missingInfo': 'Informations manquantes',
  'fin.tm.t.fillRequired': 'Veuillez remplir tous les champs obligatoires',
  'fin.tm.t.slaRuleSaved': 'Règle de SLA enregistrée',
  'fin.tm.t.ruleSavedDesc': 'Règle "{name}" enregistrée sur le serveur.',
  'fin.tm.t.saveFailed': 'Échec de l\'enregistrement',
  'fin.tm.t.updateFailed': 'Échec de la mise à jour',
  'fin.tm.t.automationRuleSaved': 'Règle d\'automatisation enregistrée',
  'fin.tm.t.reportDownloaded': 'Rapport téléchargé',
  'fin.tm.t.reportDownloadedDesc': 'Rapport {report} généré à partir de données en direct.',
  'fin.tm.t.reportFailed': 'Échec du rapport',
  'fin.tm.t.reasonRequired2': 'Motif requis',
  'fin.tm.t.provideEscReason': 'Veuillez indiquer un motif d\'escalade.',
  'fin.tm.t.escalated': 'Escaladé',
  'fin.tm.t.escalatedDesc': 'Enregistrement d\'escalade créé. ID : {id}',
  'fin.tm.t.escalationFailed': 'Échec de l\'escalade',
  'fin.tm.t.failedEscalate': 'Échec de l\'escalade.',
  'fin.tm.t.noteRequired': 'Note requise',
  'fin.tm.t.enterNote': 'Veuillez saisir une note avant d\'enregistrer.',
  'fin.tm.t.noteAdded': 'Note ajoutée',
  'fin.tm.t.noteAddedDesc': 'Note enregistrée dans la conversation {conv}.',
  'fin.tm.t.failedAddNote': 'Échec de l\'ajout de la note',
  'fin.tm.t.failedSaveNote': 'Échec de l\'enregistrement de la note.',
  'fin.tm.t.priorityUpdated': 'Priorité mise à jour',
  'fin.tm.t.priorityUpdatedDesc': 'Priorité du ticket {ticket} définie sur {priority}.',
  'fin.tm.t.priorityUpdateFailed': 'Échec de la mise à jour de la priorité',
  'fin.tm.t.resolutionRequired': 'Résolution requise',
  'fin.tm.t.provideResolution': 'Veuillez fournir un résumé de la résolution.',
  'fin.tm.t.ticketResolved': 'Ticket résolu',
  'fin.tm.t.ticketResolvedDesc': 'Ticket {ticket} résolu et enregistré.',
  'fin.tm.t.solutionSubmitted': ' Solution soumise pour approbation (ID : {id}).',
  'fin.tm.t.resolutionFailed': 'Échec de la résolution',
  'fin.tm.t.failedResolve': 'Échec de la résolution du ticket.',
  'fin.tm.t.ticketReopened': 'Ticket rouvert',
  'fin.tm.t.ticketReopenedDesc': 'Le ticket {ticket} a été rouvert et renvoyé dans la file d\'attente.',
  'fin.tm.t.reopenFailed': 'Échec de la réouverture',
  'fin.tm.t.failedReopen': 'Échec de la réouverture du ticket.',
  'fin.tm.t.assigned': 'Attribué',
  'fin.tm.t.assignedDesc': 'Ticket {ticket} attribué au membre du personnel {staff}.',
  'fin.tm.t.assignmentFailed': 'Échec de l\'attribution',
  'fin.tm.t.noConversation': 'Aucune conversation',
  'fin.tm.t.cannotSend': 'Impossible d\'envoyer : aucune conversation liée à ce ticket.',
  'fin.tm.t.messageSent': 'Message envoyé',
  'fin.tm.t.messageSentDesc': 'Le client recevra ce message.',
  'fin.tm.t.sendFailed': 'Échec de l\'envoi',
  'fin.tm.t.failedSend': 'Échec de l\'envoi du message.',
  'fin.sm.businessName': 'Nom de l\'entreprise',
  'fin.sm.description': 'Description',
  'fin.sm.address': 'Adresse',
  'fin.ov.aiVoicePerf': 'Performance de l\'agent vocal IA',
  'fin.mo.refreshMetrics': 'Actualiser les métriques',
  'fin.mf.noRatings': 'Aucune évaluation pour le moment',
  'fin.mf.marketplaceError': 'Erreur du marché :',
  'fin.mf.somethingWrong': 'Une erreur s\'est produite. Veuillez réessayer.',
  'fin.mf.enterLocation': 'Saisissez un lieu',
  'fin.mf.includesVideo': 'Comprend une vidéo',
  'fin.mf.viewDetails': 'Voir les détails',
  'fin.preview.publicProfilePreview': 'Aperçu du profil public',
  'fin.preview.showroomFallback': 'Salle d\'exposition',
  'fin.preview.businessShowroom': 'Salle d\'exposition de l\'entreprise',
  'fin.preview.businessId': 'ID de l\'entreprise :',
  'fin.preview.about': 'À propos',
  'fin.preview.noDescription': 'Aucune description disponible',
  'fin.preview.contactInfo': 'Coordonnées',
  'fin.preview.email': 'E-mail :',
  'fin.preview.phone': 'Téléphone :',
  'fin.preview.location': 'Lieu :',
  'fin.preview.notProvided': 'Non fourni',
  'fin.preview.chatAvailable': 'Chat disponible :',
  'fin.preview.inAppCalls': 'Appels dans l\'app :',
  'fin.preview.productsServices': 'Produits et services',
  'fin.preview.items': 'articles',
  'fin.preview.price': 'Prix :',
  'fin.preview.category': 'Catégorie :',
  'fin.preview.noImages': 'Aucune image',
  'fin.preview.noProducts': 'Aucun produit disponible pour le moment.',
  'fin.preview.productsWillAppear': 'Les produits apparaîtront ici une fois que vous les aurez ajoutés à votre salle d\'exposition.',
  'fin.preview.footer': 'Ceci est un aperçu du profil public de votre salle d\'exposition tel qu\'il apparaîtrait aux clients.',
};
const pt = {
  'fin.common.quickActions': 'Ações rápidas',
  'fin.tm.slaRules': 'Regras de SLA',
  'fin.tm.automation': 'Automação',
  'fin.tm.reports': 'Relatórios',
  'fin.tm.slaRulesMgmt': 'Gestão de regras de SLA',
  'fin.tm.slaRulesMgmtDesc': 'Configure as regras de acordo de nível de serviço e as políticas de escalonamento',
  'fin.tm.addSlaRule': 'Adicionar nova regra de SLA',
  'fin.tm.ruleName': 'Nome da regra *',
  'fin.tm.ruleNamePh1': 'ex.: Resposta de alta prioridade',
  'fin.tm.priorityLevel': 'Nível de prioridade',
  'fin.opt.low': 'Baixa',
  'fin.opt.medium': 'Média',
  'fin.opt.high': 'Alta',
  'fin.opt.critical': 'Crítica',
  'fin.tm.condition': 'Condição *',
  'fin.tm.conditionPh': 'ex.: Prioridade = Alta E Tipo de cliente = VIP',
  'fin.tm.action': 'Ação *',
  'fin.tm.actionPh': 'ex.: Responder em 1 hora e escalonar para o gerente',
  'fin.tm.addSlaRuleBtn': 'Adicionar regra de SLA',
  'fin.tm.activeSlaRules': 'Regras de SLA ativas',
  'fin.tm.active': 'Ativa',
  'fin.tm.inactive': 'Inativa',
  'fin.tm.when': 'Quando:',
  'fin.tm.then': 'Então:',
  'fin.tm.disable': 'Desativar',
  'fin.tm.enable': 'Ativar',
  'fin.tm.automationRules': 'Regras de automação',
  'fin.tm.automationRulesDesc': 'Configure ações automatizadas para o processamento e o fluxo de trabalho de tickets',
  'fin.tm.addAutomationRule': 'Adicionar nova regra de automação',
  'fin.tm.autoRuleNamePh': 'ex.: Atribuir automaticamente problemas técnicos',
  'fin.tm.triggerCondition': 'Condição de acionamento *',
  'fin.tm.triggerConditionPh': 'ex.: Categoria = Técnica E Prioridade = Alta',
  'fin.tm.automatedAction': 'Ação automatizada *',
  'fin.tm.automatedActionPh': 'ex.: Atribuir à equipe técnica e enviar e-mail de confirmação',
  'fin.tm.addAutomationRuleBtn': 'Adicionar regra de automação',
  'fin.tm.activeAutomationRules': 'Regras de automação ativas',
  'fin.tm.trigger': 'Acionador:',
  'fin.tm.actionLabel': 'Ação:',
  'fin.tm.reportsTitle': 'Relatórios de gestão de tickets',
  'fin.tm.reportsDesc': 'Gere relatórios abrangentes para análise de tickets e acompanhamento de desempenho',
  'fin.tm.rptSlaPerf': 'Desempenho do SLA',
  'fin.tm.rptSlaPerfSub': 'Tempos de resposta e violações',
  'fin.tm.rptAgentPerf': 'Desempenho do agente',
  'fin.tm.rptAgentPerfSub': 'Taxas de resolução e KPIs',
  'fin.tm.rptAutoEff': 'Eficiência da automação',
  'fin.tm.rptAutoEffSub': 'Desempenho das regras',
  'fin.tm.rptCsat': 'Satisfação do cliente',
  'fin.tm.rptCsatSub': 'CSAT e feedback',
  'fin.tm.totalTickets': 'Total de tickets',
  'fin.tm.highPriority': 'Alta prioridade',
  'fin.tm.slaAtRisk': 'SLA em risco',
  'fin.tm.unassigned': 'Não atribuído',
  'fin.tm.resolvedToday': 'Resolvidos hoje',
  'fin.tm.searchPh': 'Pesquisar tickets...',
  'fin.tm.priority': 'Prioridade',
  'fin.tm.allPriority': 'Todas as prioridades',
  'fin.tm.status': 'Status',
  'fin.tm.allStatus': 'Todos os status',
  'fin.tm.resolved': 'Resolvido',
  'fin.tm.inProgress': 'Em andamento',
  'fin.tm.pending': 'Pendente',
  'fin.tm.assignee': 'Responsável',
  'fin.tm.allAssignees': 'Todos os responsáveis',
  'fin.tm.apply': 'Aplicar',
  'fin.tm.applyTitle': 'Reaplicar os filtros aos tickets mais recentes',
  'fin.tm.sortTitle': 'Alternar a ordenação por data de criação',
  'fin.tm.ticketsCount': 'Tickets ({count})',
  'fin.tm.newest': 'Mais recentes',
  'fin.tm.oldest': 'Mais antigos',
  'fin.tm.loadErr': 'Falha ao carregar os tickets:',
  'fin.tm.noMatch': 'Nenhum ticket corresponde aos filtros atuais.',
  'fin.tm.assignedTo': 'Atribuído a:',
  'fin.tm.ticketDetails': 'Detalhes do ticket',
  'fin.tm.customerInfo': 'Informações do cliente',
  'fin.tm.name': 'Nome:',
  'fin.tm.tier': 'Nível:',
  'fin.tm.notConfigured': 'Não configurado',
  'fin.tm.previousTickets': 'Tickets anteriores:',
  'fin.tm.totalTicketsLbl': 'Total de tickets:',
  'fin.tm.satisfaction': 'Satisfação:',
  'fin.tm.lastTicket': 'Último ticket:',
  'fin.tm.slaManagement': 'Gestão de SLA',
  'fin.tm.statusLbl': 'Status:',
  'fin.tm.timeRemaining': 'Tempo restante:',
  'fin.tm.deadlineLbl': 'Prazo:',
  'fin.tm.noSlaConfigured': 'Nenhum SLA configurado para este ticket. Adicione uma regra de SLA (correspondente à sua prioridade) para habilitar um prazo.',
  'fin.tm.extendSla': 'Estender SLA',
  'fin.tm.assignment': 'Atribuição',
  'fin.tm.escalationHistory': 'Histórico de escalonamento',
  'fin.tm.level': 'Nível',
  'fin.tm.escalateToManager': 'Escalonar para o gerente',
  'fin.tm.escalateTicket': 'Escalonar ticket',
  'fin.tm.escalateDesc': 'Escalonar o ticket nº {id} para um gerente',
  'fin.tm.selectManager': 'Selecionar gerente *',
  'fin.tm.selectManagerPh': 'Selecionar gerente',
  'fin.tm.noManagers': 'Nenhum gerente encontrado',
  'fin.tm.urgencyLevel': 'Nível de urgência',
  'fin.tm.urgLow': 'Baixa - Escalonamento padrão',
  'fin.tm.urgNormal': 'Normal - Requer atenção',
  'fin.tm.urgHigh': 'Alta - Escalonamento urgente',
  'fin.tm.urgCritical': 'Crítica - Atenção imediata',
  'fin.tm.escalationReason': 'Motivo do escalonamento *',
  'fin.tm.escalationReasonPh': 'Explique por que este ticket precisa ser escalonado para o gerente...',
  'fin.tm.addInternalNote': 'Adicionar nota interna',
  'fin.tm.addNoteDesc': 'Adicionar uma nota interna ao ticket nº {id}',
  'fin.tm.noteVisibility': 'Visibilidade da nota',
  'fin.tm.visInternal': 'Apenas interno - A equipe pode ver',
  'fin.tm.visCustomer': 'Visível para o cliente - Incluir nas atualizações',
  'fin.tm.noteContent': 'Conteúdo da nota *',
  'fin.tm.noteContentPh': 'Digite sua nota aqui...',
  'fin.tm.addNote': 'Adicionar nota',
  'fin.tm.setPriority': 'Definir prioridade',
  'fin.tm.setTicketPriority': 'Definir prioridade do ticket',
  'fin.tm.setPriorityDesc': 'Atualizar a prioridade do ticket nº {id}',
  'fin.tm.prioLow': 'Baixa - Problema não urgente',
  'fin.tm.prioMedium': 'Média - Prioridade padrão',
  'fin.tm.prioHigh': 'Alta - Problema importante',
  'fin.tm.prioUrgent': 'Urgente - Problema crítico',
  'fin.tm.reasonForChange': 'Motivo da alteração (opcional)',
  'fin.tm.reasonForChangePh': 'Explique por que a prioridade está sendo alterada...',
  'fin.tm.updatePriority': 'Atualizar prioridade',
  'fin.tm.reopenTicket': 'Reabrir ticket',
  'fin.tm.reopenPrompt': 'Motivo da reabertura (opcional):',
  'fin.tm.markResolved': 'Marcar como resolvido',
  'fin.tm.escalate': 'Escalar',
  'fin.tm.resolutionStepsRequired': 'Insira etapas de resolução significativas (não vazias, de espaço reservado, um horário de retorno ou uma transferência) — são obrigatórias para resolver o ticket.',
  'fin.tm.resolutionStepsGovTitle': 'Conhecimento de resolução (obrigatório)',
  'fin.tm.resolutionStepsLabel': 'Etapas de resolução (obrigatório)',
  'fin.tm.solutionSubmittedNote': 'Resolução enviada ao Banco de soluções para revisão de gerente/administrador.',
  'fin.tm.myQueue': 'Minha fila',
  'fin.tm.escalatedBadge': 'Escalado',
  'fin.tm.selectOperator': 'Atribuir a operador',
  'fin.tm.selectOperatorPh': 'Selecione um operador disponível',
  'fin.tm.noOperators': 'Nenhum operador disponível',
  'fin.tm.assigneeRequired': 'Selecione um operador para atribuir',
  'fin.tm.knowledgeGovernanceHint': 'As resoluções reutilizáveis exigem etapas significativas e são revisadas por um gerente ou administrador antes da reutilização pela IA.',
  'fin.tm.resolveTicket': 'Resolver ticket',
  'fin.tm.resolveDesc': 'Marcar o ticket nº {id} como resolvido',
  'fin.tm.resolutionSummary': 'Resumo da resolução *',
  'fin.tm.resolutionSummaryPh': 'Descreva como este problema foi resolvido...',
  'fin.tm.notifyCustomer': 'Notificar o cliente sobre a resolução',
  'fin.tm.submitToBank': 'Enviar a resolução ao Banco de soluções (aguardando aprovação)',
  'fin.tm.extendSlaDesc': 'Estender o prazo do SLA para o ticket nº {id}. Isso é registrado com o seu nome e motivo.',
  'fin.tm.duration': 'Duração *',
  'fin.tm.durationPh': 'ex.: 4',
  'fin.tm.unit': 'Unidade',
  'fin.tm.hours': 'Horas',
  'fin.tm.minutes': 'Minutos',
  'fin.tm.reason': 'Motivo *',
  'fin.tm.reasonPh': 'Por que este SLA está sendo estendido?',
  'fin.tm.extending': 'Estendendo…',
  'fin.tm.quickResponse': 'Resposta rápida',
  'fin.tm.quickResponsePh': 'Digite uma mensagem para o cliente...',
  'fin.tm.sendToCustomer': 'Enviar ao cliente',
  'fin.tm.selectTicket': 'Selecione um ticket',
  'fin.tm.selectTicketDesc': 'Escolha um ticket da lista para ver os detalhes e gerenciar a atribuição',
  'fin.tm.t.invalidDuration': 'Duração inválida',
  'fin.tm.t.enterPositive': 'Insira um número positivo.',
  'fin.tm.t.reasonRequired': 'Motivo obrigatório',
  'fin.tm.t.provideReasonExt': 'Forneça um motivo para a extensão.',
  'fin.tm.t.slaExtended': 'SLA estendido',
  'fin.tm.t.slaExtendedDesc': 'Novo prazo: {deadline}.',
  'fin.tm.t.updated': 'atualizado',
  'fin.tm.t.extendFailed': 'Falha ao estender',
  'fin.tm.t.networkError': 'Erro de rede',
  'fin.tm.t.missingInfo': 'Informações faltando',
  'fin.tm.t.fillRequired': 'Preencha todos os campos obrigatórios',
  'fin.tm.t.slaRuleSaved': 'Regra de SLA salva',
  'fin.tm.t.ruleSavedDesc': 'Regra "{name}" salva no servidor.',
  'fin.tm.t.saveFailed': 'Falha ao salvar',
  'fin.tm.t.updateFailed': 'Falha ao atualizar',
  'fin.tm.t.automationRuleSaved': 'Regra de automação salva',
  'fin.tm.t.reportDownloaded': 'Relatório baixado',
  'fin.tm.t.reportDownloadedDesc': 'Relatório de {report} gerado a partir de dados ao vivo.',
  'fin.tm.t.reportFailed': 'Falha no relatório',
  'fin.tm.t.reasonRequired2': 'Motivo obrigatório',
  'fin.tm.t.provideEscReason': 'Forneça um motivo para o escalonamento.',
  'fin.tm.t.escalated': 'Escalonado',
  'fin.tm.t.escalatedDesc': 'Registro de escalonamento criado. ID: {id}',
  'fin.tm.t.escalationFailed': 'Falha no escalonamento',
  'fin.tm.t.failedEscalate': 'Falha ao escalonar.',
  'fin.tm.t.noteRequired': 'Nota obrigatória',
  'fin.tm.t.enterNote': 'Insira uma nota antes de salvar.',
  'fin.tm.t.noteAdded': 'Nota adicionada',
  'fin.tm.t.noteAddedDesc': 'Nota salva na conversa {conv}.',
  'fin.tm.t.failedAddNote': 'Falha ao adicionar a nota',
  'fin.tm.t.failedSaveNote': 'Falha ao salvar a nota.',
  'fin.tm.t.priorityUpdated': 'Prioridade atualizada',
  'fin.tm.t.priorityUpdatedDesc': 'Prioridade do ticket {ticket} definida como {priority}.',
  'fin.tm.t.priorityUpdateFailed': 'Falha ao atualizar a prioridade',
  'fin.tm.t.resolutionRequired': 'Resolução obrigatória',
  'fin.tm.t.provideResolution': 'Forneça um resumo da resolução.',
  'fin.tm.t.ticketResolved': 'Ticket resolvido',
  'fin.tm.t.ticketResolvedDesc': 'Ticket {ticket} resolvido e salvo.',
  'fin.tm.t.solutionSubmitted': ' Solução enviada para aprovação (ID: {id}).',
  'fin.tm.t.resolutionFailed': 'Falha na resolução',
  'fin.tm.t.failedResolve': 'Falha ao resolver o ticket.',
  'fin.tm.t.ticketReopened': 'Ticket reaberto',
  'fin.tm.t.ticketReopenedDesc': 'O ticket {ticket} foi reaberto e devolvido à fila.',
  'fin.tm.t.reopenFailed': 'Falha ao reabrir',
  'fin.tm.t.failedReopen': 'Falha ao reabrir o ticket.',
  'fin.tm.t.assigned': 'Atribuído',
  'fin.tm.t.assignedDesc': 'Ticket {ticket} atribuído ao funcionário {staff}.',
  'fin.tm.t.assignmentFailed': 'Falha na atribuição',
  'fin.tm.t.noConversation': 'Sem conversa',
  'fin.tm.t.cannotSend': 'Não é possível enviar: nenhuma conversa vinculada a este ticket.',
  'fin.tm.t.messageSent': 'Mensagem enviada',
  'fin.tm.t.messageSentDesc': 'O cliente receberá esta mensagem.',
  'fin.tm.t.sendFailed': 'Falha ao enviar',
  'fin.tm.t.failedSend': 'Falha ao enviar a mensagem.',
  'fin.sm.businessName': 'Nome da empresa',
  'fin.sm.description': 'Descrição',
  'fin.sm.address': 'Endereço',
  'fin.ov.aiVoicePerf': 'Desempenho do agente de voz IA',
  'fin.mo.refreshMetrics': 'Atualizar métricas',
  'fin.mf.noRatings': 'Ainda não há avaliações',
  'fin.mf.marketplaceError': 'Erro do mercado:',
  'fin.mf.somethingWrong': 'Algo deu errado. Tente novamente.',
  'fin.mf.enterLocation': 'Insira a localização',
  'fin.mf.includesVideo': 'Inclui vídeo',
  'fin.mf.viewDetails': 'Ver detalhes',
  'fin.preview.publicProfilePreview': 'Visualização do perfil público',
  'fin.preview.showroomFallback': 'Showroom',
  'fin.preview.businessShowroom': 'Showroom da empresa',
  'fin.preview.businessId': 'ID da empresa:',
  'fin.preview.about': 'Sobre',
  'fin.preview.noDescription': 'Nenhuma descrição disponível',
  'fin.preview.contactInfo': 'Informações de contato',
  'fin.preview.email': 'E-mail:',
  'fin.preview.phone': 'Telefone:',
  'fin.preview.location': 'Localização:',
  'fin.preview.notProvided': 'Não fornecido',
  'fin.preview.chatAvailable': 'Chat disponível:',
  'fin.preview.inAppCalls': 'Chamadas no app:',
  'fin.preview.productsServices': 'Produtos e serviços',
  'fin.preview.items': 'itens',
  'fin.preview.price': 'Preço:',
  'fin.preview.category': 'Categoria:',
  'fin.preview.noImages': 'Sem imagens',
  'fin.preview.noProducts': 'Nenhum produto disponível no momento.',
  'fin.preview.productsWillAppear': 'Os produtos aparecerão aqui assim que você os adicionar ao seu showroom.',
  'fin.preview.footer': 'Esta é uma visualização do perfil público do seu showroom como apareceria para os clientes.',
};
const de = {
  'fin.common.quickActions': 'Schnellaktionen',
  'fin.tm.slaRules': 'SLA-Regeln',
  'fin.tm.automation': 'Automatisierung',
  'fin.tm.reports': 'Berichte',
  'fin.tm.slaRulesMgmt': 'SLA-Regelverwaltung',
  'fin.tm.slaRulesMgmtDesc': 'Konfigurieren Sie Service-Level-Agreement-Regeln und Eskalationsrichtlinien',
  'fin.tm.addSlaRule': 'Neue SLA-Regel hinzufügen',
  'fin.tm.ruleName': 'Regelname *',
  'fin.tm.ruleNamePh1': 'z. B. Antwort mit hoher Priorität',
  'fin.tm.priorityLevel': 'Prioritätsstufe',
  'fin.opt.low': 'Niedrig',
  'fin.opt.medium': 'Mittel',
  'fin.opt.high': 'Hoch',
  'fin.opt.critical': 'Kritisch',
  'fin.tm.condition': 'Bedingung *',
  'fin.tm.conditionPh': 'z. B. Priorität = Hoch UND Kundentyp = VIP',
  'fin.tm.action': 'Aktion *',
  'fin.tm.actionPh': 'z. B. Innerhalb von 1 Stunde antworten und an den Manager eskalieren',
  'fin.tm.addSlaRuleBtn': 'SLA-Regel hinzufügen',
  'fin.tm.activeSlaRules': 'Aktive SLA-Regeln',
  'fin.tm.active': 'Aktiv',
  'fin.tm.inactive': 'Inaktiv',
  'fin.tm.when': 'Wenn:',
  'fin.tm.then': 'Dann:',
  'fin.tm.disable': 'Deaktivieren',
  'fin.tm.enable': 'Aktivieren',
  'fin.tm.automationRules': 'Automatisierungsregeln',
  'fin.tm.automationRulesDesc': 'Konfigurieren Sie automatisierte Aktionen für die Ticketbearbeitung und den Workflow',
  'fin.tm.addAutomationRule': 'Neue Automatisierungsregel hinzufügen',
  'fin.tm.autoRuleNamePh': 'z. B. Technische Probleme automatisch zuweisen',
  'fin.tm.triggerCondition': 'Auslösebedingung *',
  'fin.tm.triggerConditionPh': 'z. B. Kategorie = Technisch UND Priorität = Hoch',
  'fin.tm.automatedAction': 'Automatisierte Aktion *',
  'fin.tm.automatedActionPh': 'z. B. Dem technischen Team zuweisen und Bestätigungs-E-Mail senden',
  'fin.tm.addAutomationRuleBtn': 'Automatisierungsregel hinzufügen',
  'fin.tm.activeAutomationRules': 'Aktive Automatisierungsregeln',
  'fin.tm.trigger': 'Auslöser:',
  'fin.tm.actionLabel': 'Aktion:',
  'fin.tm.reportsTitle': 'Ticketverwaltungsberichte',
  'fin.tm.reportsDesc': 'Erstellen Sie umfassende Berichte für die Ticketanalyse und Leistungsverfolgung',
  'fin.tm.rptSlaPerf': 'SLA-Leistung',
  'fin.tm.rptSlaPerfSub': 'Antwortzeiten und Verstöße',
  'fin.tm.rptAgentPerf': 'Agentenleistung',
  'fin.tm.rptAgentPerfSub': 'Lösungsraten und KPIs',
  'fin.tm.rptAutoEff': 'Automatisierungseffizienz',
  'fin.tm.rptAutoEffSub': 'Regelleistung',
  'fin.tm.rptCsat': 'Kundenzufriedenheit',
  'fin.tm.rptCsatSub': 'CSAT und Feedback',
  'fin.tm.totalTickets': 'Tickets insgesamt',
  'fin.tm.highPriority': 'Hohe Priorität',
  'fin.tm.slaAtRisk': 'SLA gefährdet',
  'fin.tm.unassigned': 'Nicht zugewiesen',
  'fin.tm.resolvedToday': 'Heute gelöst',
  'fin.tm.searchPh': 'Tickets suchen...',
  'fin.tm.priority': 'Priorität',
  'fin.tm.allPriority': 'Alle Prioritäten',
  'fin.tm.status': 'Status',
  'fin.tm.allStatus': 'Alle Status',
  'fin.tm.resolved': 'Gelöst',
  'fin.tm.inProgress': 'In Bearbeitung',
  'fin.tm.pending': 'Ausstehend',
  'fin.tm.assignee': 'Zugewiesen an',
  'fin.tm.allAssignees': 'Alle Zuständigen',
  'fin.tm.apply': 'Anwenden',
  'fin.tm.applyTitle': 'Filter erneut auf die neuesten Tickets anwenden',
  'fin.tm.sortTitle': 'Sortierung nach Erstellungsdatum umschalten',
  'fin.tm.ticketsCount': 'Tickets ({count})',
  'fin.tm.newest': 'Neueste',
  'fin.tm.oldest': 'Älteste',
  'fin.tm.loadErr': 'Fehler beim Laden der Tickets:',
  'fin.tm.noMatch': 'Keine Tickets entsprechen den aktuellen Filtern.',
  'fin.tm.assignedTo': 'Zugewiesen an:',
  'fin.tm.ticketDetails': 'Ticketdetails',
  'fin.tm.customerInfo': 'Kundeninformationen',
  'fin.tm.name': 'Name:',
  'fin.tm.tier': 'Stufe:',
  'fin.tm.notConfigured': 'Nicht konfiguriert',
  'fin.tm.previousTickets': 'Frühere Tickets:',
  'fin.tm.totalTicketsLbl': 'Tickets insgesamt:',
  'fin.tm.satisfaction': 'Zufriedenheit:',
  'fin.tm.lastTicket': 'Letztes Ticket:',
  'fin.tm.slaManagement': 'SLA-Verwaltung',
  'fin.tm.statusLbl': 'Status:',
  'fin.tm.timeRemaining': 'Verbleibende Zeit:',
  'fin.tm.deadlineLbl': 'Frist:',
  'fin.tm.noSlaConfigured': 'Für dieses Ticket ist kein SLA konfiguriert. Fügen Sie eine SLA-Regel hinzu (passend zu seiner Priorität), um eine Frist zu aktivieren.',
  'fin.tm.extendSla': 'SLA verlängern',
  'fin.tm.assignment': 'Zuweisung',
  'fin.tm.escalationHistory': 'Eskalationsverlauf',
  'fin.tm.level': 'Stufe',
  'fin.tm.escalateToManager': 'An Manager eskalieren',
  'fin.tm.escalateTicket': 'Ticket eskalieren',
  'fin.tm.escalateDesc': 'Ticket Nr. {id} an einen Manager eskalieren',
  'fin.tm.selectManager': 'Manager auswählen *',
  'fin.tm.selectManagerPh': 'Manager auswählen',
  'fin.tm.noManagers': 'Keine Manager gefunden',
  'fin.tm.urgencyLevel': 'Dringlichkeitsstufe',
  'fin.tm.urgLow': 'Niedrig - Standardeskalation',
  'fin.tm.urgNormal': 'Normal - Erfordert Aufmerksamkeit',
  'fin.tm.urgHigh': 'Hoch - Dringende Eskalation',
  'fin.tm.urgCritical': 'Kritisch - Sofortige Aufmerksamkeit',
  'fin.tm.escalationReason': 'Eskalationsgrund *',
  'fin.tm.escalationReasonPh': 'Erklären Sie, warum dieses Ticket an den Manager eskaliert werden muss...',
  'fin.tm.addInternalNote': 'Interne Notiz hinzufügen',
  'fin.tm.addNoteDesc': 'Eine interne Notiz zu Ticket Nr. {id} hinzufügen',
  'fin.tm.noteVisibility': 'Sichtbarkeit der Notiz',
  'fin.tm.visInternal': 'Nur intern - Für Mitarbeiter sichtbar',
  'fin.tm.visCustomer': 'Für Kunden sichtbar - In Updates einbeziehen',
  'fin.tm.noteContent': 'Notizinhalt *',
  'fin.tm.noteContentPh': 'Geben Sie hier Ihre Notiz ein...',
  'fin.tm.addNote': 'Notiz hinzufügen',
  'fin.tm.setPriority': 'Priorität festlegen',
  'fin.tm.setTicketPriority': 'Ticketpriorität festlegen',
  'fin.tm.setPriorityDesc': 'Priorität für Ticket Nr. {id} aktualisieren',
  'fin.tm.prioLow': 'Niedrig - Nicht dringendes Problem',
  'fin.tm.prioMedium': 'Mittel - Standardpriorität',
  'fin.tm.prioHigh': 'Hoch - Wichtiges Problem',
  'fin.tm.prioUrgent': 'Dringend - Kritisches Problem',
  'fin.tm.reasonForChange': 'Grund für die Änderung (optional)',
  'fin.tm.reasonForChangePh': 'Erklären Sie, warum die Priorität geändert wird...',
  'fin.tm.updatePriority': 'Priorität aktualisieren',
  'fin.tm.reopenTicket': 'Ticket erneut öffnen',
  'fin.tm.reopenPrompt': 'Grund für die erneute Öffnung (optional):',
  'fin.tm.markResolved': 'Als gelöst markieren',
  'fin.tm.escalate': 'Eskalieren',
  'fin.tm.resolutionStepsRequired': 'Geben Sie aussagekräftige Lösungsschritte ein (nicht leer, kein Platzhalter, keine Rückrufzeit, keine Weiterleitung) – sie sind zum Lösen des Tickets erforderlich.',
  'fin.tm.resolutionStepsGovTitle': 'Lösungswissen (erforderlich)',
  'fin.tm.resolutionStepsLabel': 'Lösungsschritte (erforderlich)',
  'fin.tm.solutionSubmittedNote': 'Lösung zur Prüfung durch Manager/Admin an die Lösungsdatenbank gesendet.',
  'fin.tm.myQueue': 'Meine Warteschlange',
  'fin.tm.escalatedBadge': 'Eskaliert',
  'fin.tm.selectOperator': 'Operator zuweisen',
  'fin.tm.selectOperatorPh': 'Verfügbaren Operator auswählen',
  'fin.tm.noOperators': 'Keine Operatoren verfügbar',
  'fin.tm.assigneeRequired': 'Wählen Sie einen Operator zum Zuweisen',
  'fin.tm.knowledgeGovernanceHint': 'Wiederverwendbare Lösungen erfordern aussagekräftige Schritte und werden vor der KI-Wiederverwendung von einem Manager oder Admin geprüft.',
  'fin.tm.resolveTicket': 'Ticket lösen',
  'fin.tm.resolveDesc': 'Ticket Nr. {id} als gelöst markieren',
  'fin.tm.resolutionSummary': 'Lösungszusammenfassung *',
  'fin.tm.resolutionSummaryPh': 'Beschreiben Sie, wie dieses Problem gelöst wurde...',
  'fin.tm.notifyCustomer': 'Kunden über die Lösung benachrichtigen',
  'fin.tm.submitToBank': 'Lösung an die Lösungsdatenbank senden (Genehmigung ausstehend)',
  'fin.tm.extendSlaDesc': 'Verlängern Sie die SLA-Frist für Ticket Nr. {id}. Dies wird mit Ihrem Namen und Grund aufgezeichnet.',
  'fin.tm.duration': 'Dauer *',
  'fin.tm.durationPh': 'z. B. 4',
  'fin.tm.unit': 'Einheit',
  'fin.tm.hours': 'Stunden',
  'fin.tm.minutes': 'Minuten',
  'fin.tm.reason': 'Grund *',
  'fin.tm.reasonPh': 'Warum wird dieses SLA verlängert?',
  'fin.tm.extending': 'Wird verlängert…',
  'fin.tm.quickResponse': 'Schnellantwort',
  'fin.tm.quickResponsePh': 'Geben Sie eine Nachricht an den Kunden ein...',
  'fin.tm.sendToCustomer': 'An Kunden senden',
  'fin.tm.selectTicket': 'Wählen Sie ein Ticket',
  'fin.tm.selectTicketDesc': 'Wählen Sie ein Ticket aus der Liste, um Details anzuzeigen und die Zuweisung zu verwalten',
  'fin.tm.t.invalidDuration': 'Ungültige Dauer',
  'fin.tm.t.enterPositive': 'Geben Sie eine positive Zahl ein.',
  'fin.tm.t.reasonRequired': 'Grund erforderlich',
  'fin.tm.t.provideReasonExt': 'Bitte geben Sie einen Grund für die Verlängerung an.',
  'fin.tm.t.slaExtended': 'SLA verlängert',
  'fin.tm.t.slaExtendedDesc': 'Neue Frist: {deadline}.',
  'fin.tm.t.updated': 'aktualisiert',
  'fin.tm.t.extendFailed': 'Verlängerung fehlgeschlagen',
  'fin.tm.t.networkError': 'Netzwerkfehler',
  'fin.tm.t.missingInfo': 'Fehlende Informationen',
  'fin.tm.t.fillRequired': 'Bitte füllen Sie alle Pflichtfelder aus',
  'fin.tm.t.slaRuleSaved': 'SLA-Regel gespeichert',
  'fin.tm.t.ruleSavedDesc': 'Regel "{name}" auf dem Server gespeichert.',
  'fin.tm.t.saveFailed': 'Speichern fehlgeschlagen',
  'fin.tm.t.updateFailed': 'Aktualisierung fehlgeschlagen',
  'fin.tm.t.automationRuleSaved': 'Automatisierungsregel gespeichert',
  'fin.tm.t.reportDownloaded': 'Bericht heruntergeladen',
  'fin.tm.t.reportDownloadedDesc': 'Bericht "{report}" aus Live-Daten erstellt.',
  'fin.tm.t.reportFailed': 'Bericht fehlgeschlagen',
  'fin.tm.t.reasonRequired2': 'Grund erforderlich',
  'fin.tm.t.provideEscReason': 'Bitte geben Sie einen Eskalationsgrund an.',
  'fin.tm.t.escalated': 'Eskaliert',
  'fin.tm.t.escalatedDesc': 'Eskalationsdatensatz erstellt. ID: {id}',
  'fin.tm.t.escalationFailed': 'Eskalation fehlgeschlagen',
  'fin.tm.t.failedEscalate': 'Eskalation fehlgeschlagen.',
  'fin.tm.t.noteRequired': 'Notiz erforderlich',
  'fin.tm.t.enterNote': 'Bitte geben Sie vor dem Speichern eine Notiz ein.',
  'fin.tm.t.noteAdded': 'Notiz hinzugefügt',
  'fin.tm.t.noteAddedDesc': 'Notiz in Konversation {conv} gespeichert.',
  'fin.tm.t.failedAddNote': 'Hinzufügen der Notiz fehlgeschlagen',
  'fin.tm.t.failedSaveNote': 'Speichern der Notiz fehlgeschlagen.',
  'fin.tm.t.priorityUpdated': 'Priorität aktualisiert',
  'fin.tm.t.priorityUpdatedDesc': 'Priorität von Ticket {ticket} auf {priority} gesetzt.',
  'fin.tm.t.priorityUpdateFailed': 'Prioritätsaktualisierung fehlgeschlagen',
  'fin.tm.t.resolutionRequired': 'Lösung erforderlich',
  'fin.tm.t.provideResolution': 'Bitte geben Sie eine Lösungszusammenfassung an.',
  'fin.tm.t.ticketResolved': 'Ticket gelöst',
  'fin.tm.t.ticketResolvedDesc': 'Ticket {ticket} gelöst und gespeichert.',
  'fin.tm.t.solutionSubmitted': ' Lösung zur Genehmigung eingereicht (ID: {id}).',
  'fin.tm.t.resolutionFailed': 'Lösung fehlgeschlagen',
  'fin.tm.t.failedResolve': 'Ticket konnte nicht gelöst werden.',
  'fin.tm.t.ticketReopened': 'Ticket erneut geöffnet',
  'fin.tm.t.ticketReopenedDesc': 'Ticket {ticket} wurde erneut geöffnet und in die Warteschlange zurückgestellt.',
  'fin.tm.t.reopenFailed': 'Erneutes Öffnen fehlgeschlagen',
  'fin.tm.t.failedReopen': 'Ticket konnte nicht erneut geöffnet werden.',
  'fin.tm.t.assigned': 'Zugewiesen',
  'fin.tm.t.assignedDesc': 'Ticket {ticket} dem Mitarbeiter {staff} zugewiesen.',
  'fin.tm.t.assignmentFailed': 'Zuweisung fehlgeschlagen',
  'fin.tm.t.noConversation': 'Keine Konversation',
  'fin.tm.t.cannotSend': 'Senden nicht möglich: keine mit diesem Ticket verknüpfte Konversation.',
  'fin.tm.t.messageSent': 'Nachricht gesendet',
  'fin.tm.t.messageSentDesc': 'Der Kunde erhält diese Nachricht.',
  'fin.tm.t.sendFailed': 'Senden fehlgeschlagen',
  'fin.tm.t.failedSend': 'Nachricht konnte nicht gesendet werden.',
  'fin.sm.businessName': 'Firmenname',
  'fin.sm.description': 'Beschreibung',
  'fin.sm.address': 'Adresse',
  'fin.ov.aiVoicePerf': 'Leistung des KI-Sprachagenten',
  'fin.mo.refreshMetrics': 'Kennzahlen aktualisieren',
  'fin.mf.noRatings': 'Noch keine Bewertungen',
  'fin.mf.marketplaceError': 'Marktplatzfehler:',
  'fin.mf.somethingWrong': 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.',
  'fin.mf.enterLocation': 'Standort eingeben',
  'fin.mf.includesVideo': 'Enthält Video',
  'fin.mf.viewDetails': 'Details anzeigen',
  'fin.preview.publicProfilePreview': 'Vorschau des öffentlichen Profils',
  'fin.preview.showroomFallback': 'Showroom',
  'fin.preview.businessShowroom': 'Firmen-Showroom',
  'fin.preview.businessId': 'Firmen-ID:',
  'fin.preview.about': 'Über uns',
  'fin.preview.noDescription': 'Keine Beschreibung verfügbar',
  'fin.preview.contactInfo': 'Kontaktinformationen',
  'fin.preview.email': 'E-Mail:',
  'fin.preview.phone': 'Telefon:',
  'fin.preview.location': 'Standort:',
  'fin.preview.notProvided': 'Nicht angegeben',
  'fin.preview.chatAvailable': 'Chat verfügbar:',
  'fin.preview.inAppCalls': 'In-App-Anrufe:',
  'fin.preview.productsServices': 'Produkte und Dienstleistungen',
  'fin.preview.items': 'Artikel',
  'fin.preview.price': 'Preis:',
  'fin.preview.category': 'Kategorie:',
  'fin.preview.noImages': 'Keine Bilder',
  'fin.preview.noProducts': 'Derzeit sind keine Produkte verfügbar.',
  'fin.preview.productsWillAppear': 'Produkte werden hier angezeigt, sobald Sie sie Ihrem Showroom hinzufügen.',
  'fin.preview.footer': 'Dies ist eine Vorschau des öffentlichen Profils Ihres Showrooms, wie es für Kunden angezeigt würde.',
};
const it = {
  'fin.common.quickActions': 'Azioni rapide',
  'fin.tm.slaRules': 'Regole SLA',
  'fin.tm.automation': 'Automazione',
  'fin.tm.reports': 'Report',
  'fin.tm.slaRulesMgmt': 'Gestione delle regole SLA',
  'fin.tm.slaRulesMgmtDesc': 'Configura le regole dell\'accordo sul livello di servizio e le politiche di escalation',
  'fin.tm.addSlaRule': 'Aggiungi nuova regola SLA',
  'fin.tm.ruleName': 'Nome della regola *',
  'fin.tm.ruleNamePh1': 'ad es., Risposta ad alta priorità',
  'fin.tm.priorityLevel': 'Livello di priorità',
  'fin.opt.low': 'Bassa',
  'fin.opt.medium': 'Media',
  'fin.opt.high': 'Alta',
  'fin.opt.critical': 'Critica',
  'fin.tm.condition': 'Condizione *',
  'fin.tm.conditionPh': 'ad es., Priorità = Alta E Tipo di cliente = VIP',
  'fin.tm.action': 'Azione *',
  'fin.tm.actionPh': 'ad es., Rispondere entro 1 ora ed effettuare l\'escalation al responsabile',
  'fin.tm.addSlaRuleBtn': 'Aggiungi regola SLA',
  'fin.tm.activeSlaRules': 'Regole SLA attive',
  'fin.tm.active': 'Attiva',
  'fin.tm.inactive': 'Inattiva',
  'fin.tm.when': 'Quando:',
  'fin.tm.then': 'Allora:',
  'fin.tm.disable': 'Disattiva',
  'fin.tm.enable': 'Attiva',
  'fin.tm.automationRules': 'Regole di automazione',
  'fin.tm.automationRulesDesc': 'Configura azioni automatizzate per l\'elaborazione e il flusso di lavoro dei ticket',
  'fin.tm.addAutomationRule': 'Aggiungi nuova regola di automazione',
  'fin.tm.autoRuleNamePh': 'ad es., Assegna automaticamente i problemi tecnici',
  'fin.tm.triggerCondition': 'Condizione di attivazione *',
  'fin.tm.triggerConditionPh': 'ad es., Categoria = Tecnica E Priorità = Alta',
  'fin.tm.automatedAction': 'Azione automatizzata *',
  'fin.tm.automatedActionPh': 'ad es., Assegna al team tecnico e invia e-mail di conferma',
  'fin.tm.addAutomationRuleBtn': 'Aggiungi regola di automazione',
  'fin.tm.activeAutomationRules': 'Regole di automazione attive',
  'fin.tm.trigger': 'Attivatore:',
  'fin.tm.actionLabel': 'Azione:',
  'fin.tm.reportsTitle': 'Report di gestione dei ticket',
  'fin.tm.reportsDesc': 'Genera report completi per l\'analisi dei ticket e il monitoraggio delle prestazioni',
  'fin.tm.rptSlaPerf': 'Prestazioni SLA',
  'fin.tm.rptSlaPerfSub': 'Tempi di risposta e violazioni',
  'fin.tm.rptAgentPerf': 'Prestazioni dell\'agente',
  'fin.tm.rptAgentPerfSub': 'Tassi di risoluzione e KPI',
  'fin.tm.rptAutoEff': 'Efficienza dell\'automazione',
  'fin.tm.rptAutoEffSub': 'Prestazioni delle regole',
  'fin.tm.rptCsat': 'Soddisfazione del cliente',
  'fin.tm.rptCsatSub': 'CSAT e feedback',
  'fin.tm.totalTickets': 'Ticket totali',
  'fin.tm.highPriority': 'Alta priorità',
  'fin.tm.slaAtRisk': 'SLA a rischio',
  'fin.tm.unassigned': 'Non assegnato',
  'fin.tm.resolvedToday': 'Risolti oggi',
  'fin.tm.searchPh': 'Cerca ticket...',
  'fin.tm.priority': 'Priorità',
  'fin.tm.allPriority': 'Tutte le priorità',
  'fin.tm.status': 'Stato',
  'fin.tm.allStatus': 'Tutti gli stati',
  'fin.tm.resolved': 'Risolto',
  'fin.tm.inProgress': 'In corso',
  'fin.tm.pending': 'In attesa',
  'fin.tm.assignee': 'Assegnatario',
  'fin.tm.allAssignees': 'Tutti gli assegnatari',
  'fin.tm.apply': 'Applica',
  'fin.tm.applyTitle': 'Riapplica i filtri ai ticket più recenti',
  'fin.tm.sortTitle': 'Attiva/disattiva l\'ordinamento per data di creazione',
  'fin.tm.ticketsCount': 'Ticket ({count})',
  'fin.tm.newest': 'Più recenti',
  'fin.tm.oldest': 'Meno recenti',
  'fin.tm.loadErr': 'Impossibile caricare i ticket:',
  'fin.tm.noMatch': 'Nessun ticket corrisponde ai filtri attuali.',
  'fin.tm.assignedTo': 'Assegnato a:',
  'fin.tm.ticketDetails': 'Dettagli del ticket',
  'fin.tm.customerInfo': 'Informazioni sul cliente',
  'fin.tm.name': 'Nome:',
  'fin.tm.tier': 'Livello:',
  'fin.tm.notConfigured': 'Non configurato',
  'fin.tm.previousTickets': 'Ticket precedenti:',
  'fin.tm.totalTicketsLbl': 'Ticket totali:',
  'fin.tm.satisfaction': 'Soddisfazione:',
  'fin.tm.lastTicket': 'Ultimo ticket:',
  'fin.tm.slaManagement': 'Gestione SLA',
  'fin.tm.statusLbl': 'Stato:',
  'fin.tm.timeRemaining': 'Tempo rimanente:',
  'fin.tm.deadlineLbl': 'Scadenza:',
  'fin.tm.noSlaConfigured': 'Nessuno SLA configurato per questo ticket. Aggiungi una regola SLA (corrispondente alla sua priorità) per abilitare una scadenza.',
  'fin.tm.extendSla': 'Estendi SLA',
  'fin.tm.assignment': 'Assegnazione',
  'fin.tm.escalationHistory': 'Cronologia delle escalation',
  'fin.tm.level': 'Livello',
  'fin.tm.escalateToManager': 'Escalation al responsabile',
  'fin.tm.escalateTicket': 'Escalation del ticket',
  'fin.tm.escalateDesc': 'Escalation del ticket n. {id} a un responsabile',
  'fin.tm.selectManager': 'Seleziona responsabile *',
  'fin.tm.selectManagerPh': 'Seleziona responsabile',
  'fin.tm.noManagers': 'Nessun responsabile trovato',
  'fin.tm.urgencyLevel': 'Livello di urgenza',
  'fin.tm.urgLow': 'Bassa - Escalation standard',
  'fin.tm.urgNormal': 'Normale - Richiede attenzione',
  'fin.tm.urgHigh': 'Alta - Escalation urgente',
  'fin.tm.urgCritical': 'Critica - Attenzione immediata',
  'fin.tm.escalationReason': 'Motivo dell\'escalation *',
  'fin.tm.escalationReasonPh': 'Spiega perché questo ticket necessita di escalation al responsabile...',
  'fin.tm.addInternalNote': 'Aggiungi nota interna',
  'fin.tm.addNoteDesc': 'Aggiungi una nota interna al ticket n. {id}',
  'fin.tm.noteVisibility': 'Visibilità della nota',
  'fin.tm.visInternal': 'Solo interna - Il personale può vederla',
  'fin.tm.visCustomer': 'Visibile al cliente - Includi negli aggiornamenti',
  'fin.tm.noteContent': 'Contenuto della nota *',
  'fin.tm.noteContentPh': 'Inserisci qui la tua nota...',
  'fin.tm.addNote': 'Aggiungi nota',
  'fin.tm.setPriority': 'Imposta priorità',
  'fin.tm.setTicketPriority': 'Imposta priorità del ticket',
  'fin.tm.setPriorityDesc': 'Aggiorna la priorità del ticket n. {id}',
  'fin.tm.prioLow': 'Bassa - Problema non urgente',
  'fin.tm.prioMedium': 'Media - Priorità standard',
  'fin.tm.prioHigh': 'Alta - Problema importante',
  'fin.tm.prioUrgent': 'Urgente - Problema critico',
  'fin.tm.reasonForChange': 'Motivo della modifica (facoltativo)',
  'fin.tm.reasonForChangePh': 'Spiega perché la priorità viene modificata...',
  'fin.tm.updatePriority': 'Aggiorna priorità',
  'fin.tm.reopenTicket': 'Riapri ticket',
  'fin.tm.reopenPrompt': 'Motivo della riapertura (facoltativo):',
  'fin.tm.markResolved': 'Segna come risolto',
  'fin.tm.escalate': 'Inoltra',
  'fin.tm.resolutionStepsRequired': 'Inserisci passaggi di risoluzione significativi (non vuoti, segnaposto, un orario di richiamata o un trasferimento): sono obbligatori per risolvere il ticket.',
  'fin.tm.resolutionStepsGovTitle': 'Conoscenza della risoluzione (obbligatoria)',
  'fin.tm.resolutionStepsLabel': 'Passaggi di risoluzione (obbligatorio)',
  'fin.tm.solutionSubmittedNote': 'Risoluzione inviata alla Banca delle soluzioni per la revisione di responsabile/amministratore.',
  'fin.tm.myQueue': 'La mia coda',
  'fin.tm.escalatedBadge': 'Inoltrato',
  'fin.tm.selectOperator': 'Assegna a operatore',
  'fin.tm.selectOperatorPh': 'Seleziona un operatore disponibile',
  'fin.tm.noOperators': 'Nessun operatore disponibile',
  'fin.tm.assigneeRequired': 'Seleziona un operatore da assegnare',
  'fin.tm.knowledgeGovernanceHint': 'Le risoluzioni riutilizzabili richiedono passaggi significativi e vengono esaminate da un responsabile o amministratore prima del riutilizzo da parte dell’IA.',
  'fin.tm.resolveTicket': 'Risolvi ticket',
  'fin.tm.resolveDesc': 'Segna il ticket n. {id} come risolto',
  'fin.tm.resolutionSummary': 'Riepilogo della risoluzione *',
  'fin.tm.resolutionSummaryPh': 'Descrivi come è stato risolto questo problema...',
  'fin.tm.notifyCustomer': 'Notifica al cliente la risoluzione',
  'fin.tm.submitToBank': 'Invia la risoluzione alla Banca delle soluzioni (in attesa di approvazione)',
  'fin.tm.extendSlaDesc': 'Estendi la scadenza SLA per il ticket n. {id}. Questa operazione viene registrata con il tuo nome e il motivo.',
  'fin.tm.duration': 'Durata *',
  'fin.tm.durationPh': 'ad es. 4',
  'fin.tm.unit': 'Unità',
  'fin.tm.hours': 'Ore',
  'fin.tm.minutes': 'Minuti',
  'fin.tm.reason': 'Motivo *',
  'fin.tm.reasonPh': 'Perché questo SLA viene esteso?',
  'fin.tm.extending': 'Estensione…',
  'fin.tm.quickResponse': 'Risposta rapida',
  'fin.tm.quickResponsePh': 'Digita un messaggio per il cliente...',
  'fin.tm.sendToCustomer': 'Invia al cliente',
  'fin.tm.selectTicket': 'Seleziona un ticket',
  'fin.tm.selectTicketDesc': 'Scegli un ticket dall\'elenco per visualizzare i dettagli e gestire l\'assegnazione',
  'fin.tm.t.invalidDuration': 'Durata non valida',
  'fin.tm.t.enterPositive': 'Inserisci un numero positivo.',
  'fin.tm.t.reasonRequired': 'Motivo obbligatorio',
  'fin.tm.t.provideReasonExt': 'Fornisci un motivo per l\'estensione.',
  'fin.tm.t.slaExtended': 'SLA esteso',
  'fin.tm.t.slaExtendedDesc': 'Nuova scadenza: {deadline}.',
  'fin.tm.t.updated': 'aggiornata',
  'fin.tm.t.extendFailed': 'Estensione non riuscita',
  'fin.tm.t.networkError': 'Errore di rete',
  'fin.tm.t.missingInfo': 'Informazioni mancanti',
  'fin.tm.t.fillRequired': 'Compila tutti i campi obbligatori',
  'fin.tm.t.slaRuleSaved': 'Regola SLA salvata',
  'fin.tm.t.ruleSavedDesc': 'Regola "{name}" salvata sul server.',
  'fin.tm.t.saveFailed': 'Salvataggio non riuscito',
  'fin.tm.t.updateFailed': 'Aggiornamento non riuscito',
  'fin.tm.t.automationRuleSaved': 'Regola di automazione salvata',
  'fin.tm.t.reportDownloaded': 'Report scaricato',
  'fin.tm.t.reportDownloadedDesc': 'Report {report} generato da dati in tempo reale.',
  'fin.tm.t.reportFailed': 'Report non riuscito',
  'fin.tm.t.reasonRequired2': 'Motivo obbligatorio',
  'fin.tm.t.provideEscReason': 'Fornisci un motivo per l\'escalation.',
  'fin.tm.t.escalated': 'Escalation effettuata',
  'fin.tm.t.escalatedDesc': 'Record di escalation creato. ID: {id}',
  'fin.tm.t.escalationFailed': 'Escalation non riuscita',
  'fin.tm.t.failedEscalate': 'Impossibile effettuare l\'escalation.',
  'fin.tm.t.noteRequired': 'Nota obbligatoria',
  'fin.tm.t.enterNote': 'Inserisci una nota prima di salvare.',
  'fin.tm.t.noteAdded': 'Nota aggiunta',
  'fin.tm.t.noteAddedDesc': 'Nota salvata nella conversazione {conv}.',
  'fin.tm.t.failedAddNote': 'Impossibile aggiungere la nota',
  'fin.tm.t.failedSaveNote': 'Impossibile salvare la nota.',
  'fin.tm.t.priorityUpdated': 'Priorità aggiornata',
  'fin.tm.t.priorityUpdatedDesc': 'Priorità del ticket {ticket} impostata su {priority}.',
  'fin.tm.t.priorityUpdateFailed': 'Aggiornamento della priorità non riuscito',
  'fin.tm.t.resolutionRequired': 'Risoluzione obbligatoria',
  'fin.tm.t.provideResolution': 'Fornisci un riepilogo della risoluzione.',
  'fin.tm.t.ticketResolved': 'Ticket risolto',
  'fin.tm.t.ticketResolvedDesc': 'Ticket {ticket} risolto e salvato.',
  'fin.tm.t.solutionSubmitted': ' Soluzione inviata per l\'approvazione (ID: {id}).',
  'fin.tm.t.resolutionFailed': 'Risoluzione non riuscita',
  'fin.tm.t.failedResolve': 'Impossibile risolvere il ticket.',
  'fin.tm.t.ticketReopened': 'Ticket riaperto',
  'fin.tm.t.ticketReopenedDesc': 'Il ticket {ticket} è stato riaperto e rimesso in coda.',
  'fin.tm.t.reopenFailed': 'Riapertura non riuscita',
  'fin.tm.t.failedReopen': 'Impossibile riaprire il ticket.',
  'fin.tm.t.assigned': 'Assegnato',
  'fin.tm.t.assignedDesc': 'Ticket {ticket} assegnato al membro del personale {staff}.',
  'fin.tm.t.assignmentFailed': 'Assegnazione non riuscita',
  'fin.tm.t.noConversation': 'Nessuna conversazione',
  'fin.tm.t.cannotSend': 'Impossibile inviare: nessuna conversazione collegata a questo ticket.',
  'fin.tm.t.messageSent': 'Messaggio inviato',
  'fin.tm.t.messageSentDesc': 'Il cliente riceverà questo messaggio.',
  'fin.tm.t.sendFailed': 'Invio non riuscito',
  'fin.tm.t.failedSend': 'Impossibile inviare il messaggio.',
  'fin.sm.businessName': 'Nome dell\'azienda',
  'fin.sm.description': 'Descrizione',
  'fin.sm.address': 'Indirizzo',
  'fin.ov.aiVoicePerf': 'Prestazioni dell\'agente vocale IA',
  'fin.mo.refreshMetrics': 'Aggiorna metriche',
  'fin.mf.noRatings': 'Ancora nessuna valutazione',
  'fin.mf.marketplaceError': 'Errore del marketplace:',
  'fin.mf.somethingWrong': 'Si è verificato un errore. Riprova.',
  'fin.mf.enterLocation': 'Inserisci la posizione',
  'fin.mf.includesVideo': 'Include video',
  'fin.mf.viewDetails': 'Visualizza dettagli',
  'fin.preview.publicProfilePreview': 'Anteprima del profilo pubblico',
  'fin.preview.showroomFallback': 'Showroom',
  'fin.preview.businessShowroom': 'Showroom aziendale',
  'fin.preview.businessId': 'ID azienda:',
  'fin.preview.about': 'Informazioni',
  'fin.preview.noDescription': 'Nessuna descrizione disponibile',
  'fin.preview.contactInfo': 'Informazioni di contatto',
  'fin.preview.email': 'E-mail:',
  'fin.preview.phone': 'Telefono:',
  'fin.preview.location': 'Posizione:',
  'fin.preview.notProvided': 'Non fornito',
  'fin.preview.chatAvailable': 'Chat disponibile:',
  'fin.preview.inAppCalls': 'Chiamate in-app:',
  'fin.preview.productsServices': 'Prodotti e servizi',
  'fin.preview.items': 'articoli',
  'fin.preview.price': 'Prezzo:',
  'fin.preview.category': 'Categoria:',
  'fin.preview.noImages': 'Nessuna immagine',
  'fin.preview.noProducts': 'Nessun prodotto disponibile al momento.',
  'fin.preview.productsWillAppear': 'I prodotti appariranno qui una volta aggiunti al tuo showroom.',
  'fin.preview.footer': 'Questa è un\'anteprima del profilo pubblico del tuo showroom come apparirebbe ai clienti.',
};
const ja = {
  'fin.common.quickActions': 'クイックアクション',
  'fin.tm.slaRules': 'SLAルール',
  'fin.tm.automation': '自動化',
  'fin.tm.reports': 'レポート',
  'fin.tm.slaRulesMgmt': 'SLAルール管理',
  'fin.tm.slaRulesMgmtDesc': 'サービスレベル契約ルールとエスカレーションポリシーを設定します',
  'fin.tm.addSlaRule': '新しいSLAルールを追加',
  'fin.tm.ruleName': 'ルール名 *',
  'fin.tm.ruleNamePh1': '例: 高優先度の対応',
  'fin.tm.priorityLevel': '優先度レベル',
  'fin.opt.low': '低',
  'fin.opt.medium': '中',
  'fin.opt.high': '高',
  'fin.opt.critical': '重大',
  'fin.tm.condition': '条件 *',
  'fin.tm.conditionPh': '例: 優先度 = 高 かつ 顧客タイプ = VIP',
  'fin.tm.action': 'アクション *',
  'fin.tm.actionPh': '例: 1時間以内に対応し、マネージャーにエスカレーションする',
  'fin.tm.addSlaRuleBtn': 'SLAルールを追加',
  'fin.tm.activeSlaRules': '有効なSLAルール',
  'fin.tm.active': '有効',
  'fin.tm.inactive': '無効',
  'fin.tm.when': '条件:',
  'fin.tm.then': '実行:',
  'fin.tm.disable': '無効にする',
  'fin.tm.enable': '有効にする',
  'fin.tm.automationRules': '自動化ルール',
  'fin.tm.automationRulesDesc': 'チケットの処理とワークフローのための自動アクションを設定します',
  'fin.tm.addAutomationRule': '新しい自動化ルールを追加',
  'fin.tm.autoRuleNamePh': '例: 技術的な問題を自動割り当て',
  'fin.tm.triggerCondition': 'トリガー条件 *',
  'fin.tm.triggerConditionPh': '例: カテゴリ = 技術 かつ 優先度 = 高',
  'fin.tm.automatedAction': '自動アクション *',
  'fin.tm.automatedActionPh': '例: 技術チームに割り当て、確認メールを送信',
  'fin.tm.addAutomationRuleBtn': '自動化ルールを追加',
  'fin.tm.activeAutomationRules': '有効な自動化ルール',
  'fin.tm.trigger': 'トリガー:',
  'fin.tm.actionLabel': 'アクション:',
  'fin.tm.reportsTitle': 'チケット管理レポート',
  'fin.tm.reportsDesc': 'チケット分析とパフォーマンス追跡のための包括的なレポートを生成します',
  'fin.tm.rptSlaPerf': 'SLAパフォーマンス',
  'fin.tm.rptSlaPerfSub': '応答時間と違反',
  'fin.tm.rptAgentPerf': 'エージェントのパフォーマンス',
  'fin.tm.rptAgentPerfSub': '解決率とKPI',
  'fin.tm.rptAutoEff': '自動化の効率',
  'fin.tm.rptAutoEffSub': 'ルールのパフォーマンス',
  'fin.tm.rptCsat': '顧客満足度',
  'fin.tm.rptCsatSub': 'CSATとフィードバック',
  'fin.tm.totalTickets': 'チケット総数',
  'fin.tm.highPriority': '高優先度',
  'fin.tm.slaAtRisk': 'SLAリスクあり',
  'fin.tm.unassigned': '未割り当て',
  'fin.tm.resolvedToday': '本日解決済み',
  'fin.tm.searchPh': 'チケットを検索...',
  'fin.tm.priority': '優先度',
  'fin.tm.allPriority': 'すべての優先度',
  'fin.tm.status': 'ステータス',
  'fin.tm.allStatus': 'すべてのステータス',
  'fin.tm.resolved': '解決済み',
  'fin.tm.inProgress': '進行中',
  'fin.tm.pending': '保留中',
  'fin.tm.assignee': '担当者',
  'fin.tm.allAssignees': 'すべての担当者',
  'fin.tm.apply': '適用',
  'fin.tm.applyTitle': '最新のチケットにフィルターを再適用',
  'fin.tm.sortTitle': '作成日で並べ替えを切り替え',
  'fin.tm.ticketsCount': 'チケット ({count})',
  'fin.tm.newest': '新しい順',
  'fin.tm.oldest': '古い順',
  'fin.tm.loadErr': 'チケットの読み込みに失敗しました:',
  'fin.tm.noMatch': '現在のフィルターに一致するチケットはありません。',
  'fin.tm.assignedTo': '担当:',
  'fin.tm.ticketDetails': 'チケットの詳細',
  'fin.tm.customerInfo': '顧客情報',
  'fin.tm.name': '名前:',
  'fin.tm.tier': 'ティア:',
  'fin.tm.notConfigured': '未設定',
  'fin.tm.previousTickets': '過去のチケット:',
  'fin.tm.totalTicketsLbl': 'チケット総数:',
  'fin.tm.satisfaction': '満足度:',
  'fin.tm.lastTicket': '最後のチケット:',
  'fin.tm.slaManagement': 'SLA管理',
  'fin.tm.statusLbl': 'ステータス:',
  'fin.tm.timeRemaining': '残り時間:',
  'fin.tm.deadlineLbl': '期限:',
  'fin.tm.noSlaConfigured': 'このチケットにはSLAが設定されていません。期限を有効にするには、その優先度に一致するSLAルールを追加してください。',
  'fin.tm.extendSla': 'SLAを延長',
  'fin.tm.assignment': '割り当て',
  'fin.tm.escalationHistory': 'エスカレーション履歴',
  'fin.tm.level': 'レベル',
  'fin.tm.escalateToManager': 'マネージャーにエスカレーション',
  'fin.tm.escalateTicket': 'チケットをエスカレーション',
  'fin.tm.escalateDesc': 'チケット #{id} をマネージャーにエスカレーションします',
  'fin.tm.selectManager': 'マネージャーを選択 *',
  'fin.tm.selectManagerPh': 'マネージャーを選択',
  'fin.tm.noManagers': 'マネージャーが見つかりません',
  'fin.tm.urgencyLevel': '緊急度レベル',
  'fin.tm.urgLow': '低 - 標準エスカレーション',
  'fin.tm.urgNormal': '通常 - 対応が必要',
  'fin.tm.urgHigh': '高 - 緊急エスカレーション',
  'fin.tm.urgCritical': '重大 - 即時対応',
  'fin.tm.escalationReason': 'エスカレーションの理由 *',
  'fin.tm.escalationReasonPh': 'このチケットをマネージャーにエスカレーションする理由を説明してください...',
  'fin.tm.addInternalNote': '内部メモを追加',
  'fin.tm.addNoteDesc': 'チケット #{id} に内部メモを追加します',
  'fin.tm.noteVisibility': 'メモの公開範囲',
  'fin.tm.visInternal': '内部のみ - スタッフが閲覧可能',
  'fin.tm.visCustomer': '顧客に表示 - 更新情報に含める',
  'fin.tm.noteContent': 'メモの内容 *',
  'fin.tm.noteContentPh': 'ここにメモを入力してください...',
  'fin.tm.addNote': 'メモを追加',
  'fin.tm.setPriority': '優先度を設定',
  'fin.tm.setTicketPriority': 'チケットの優先度を設定',
  'fin.tm.setPriorityDesc': 'チケット #{id} の優先度を更新します',
  'fin.tm.prioLow': '低 - 緊急でない問題',
  'fin.tm.prioMedium': '中 - 標準の優先度',
  'fin.tm.prioHigh': '高 - 重要な問題',
  'fin.tm.prioUrgent': '緊急 - 重大な問題',
  'fin.tm.reasonForChange': '変更の理由（任意）',
  'fin.tm.reasonForChangePh': '優先度を変更する理由を説明してください...',
  'fin.tm.updatePriority': '優先度を更新',
  'fin.tm.reopenTicket': 'チケットを再開',
  'fin.tm.reopenPrompt': '再開の理由（任意）:',
  'fin.tm.markResolved': '解決済みにする',
  'fin.tm.escalate': 'エスカレーション',
  'fin.tm.resolutionStepsRequired': '意味のある解決手順を入力してください（空・プレースホルダー・折り返し時刻・転送は不可）。チケットの解決に必須です。',
  'fin.tm.resolutionStepsGovTitle': '解決ナレッジ（必須）',
  'fin.tm.resolutionStepsLabel': '解決手順（必須）',
  'fin.tm.solutionSubmittedNote': '解決策をソリューションバンクに送信しました（マネージャー/管理者の審査待ち）。',
  'fin.tm.myQueue': 'マイキュー',
  'fin.tm.escalatedBadge': 'エスカレーション済み',
  'fin.tm.selectOperator': 'オペレーターに割り当て',
  'fin.tm.selectOperatorPh': '利用可能なオペレーターを選択',
  'fin.tm.noOperators': '利用可能なオペレーターがいません',
  'fin.tm.assigneeRequired': '割り当てるオペレーターを選択してください',
  'fin.tm.knowledgeGovernanceHint': '再利用可能な解決策には具体的な手順が必要で、AIが再利用する前にマネージャーまたは管理者が審査します。',
  'fin.tm.resolveTicket': 'チケットを解決',
  'fin.tm.resolveDesc': 'チケット #{id} を解決済みにします',
  'fin.tm.resolutionSummary': '解決の概要 *',
  'fin.tm.resolutionSummaryPh': 'この問題がどのように解決されたかを説明してください...',
  'fin.tm.notifyCustomer': '解決について顧客に通知する',
  'fin.tm.submitToBank': '解決策をソリューションバンクに送信（承認待ち）',
  'fin.tm.extendSlaDesc': 'チケット #{id} のSLA期限を延長します。これはあなたの名前と理由とともに記録されます。',
  'fin.tm.duration': '期間 *',
  'fin.tm.durationPh': '例: 4',
  'fin.tm.unit': '単位',
  'fin.tm.hours': '時間',
  'fin.tm.minutes': '分',
  'fin.tm.reason': '理由 *',
  'fin.tm.reasonPh': 'このSLAを延長する理由は何ですか？',
  'fin.tm.extending': '延長中…',
  'fin.tm.quickResponse': 'クイック返信',
  'fin.tm.quickResponsePh': '顧客へのメッセージを入力...',
  'fin.tm.sendToCustomer': '顧客に送信',
  'fin.tm.selectTicket': 'チケットを選択',
  'fin.tm.selectTicketDesc': 'リストからチケットを選択して詳細を表示し、割り当てを管理します',
  'fin.tm.t.invalidDuration': '無効な期間',
  'fin.tm.t.enterPositive': '正の数を入力してください。',
  'fin.tm.t.reasonRequired': '理由が必要です',
  'fin.tm.t.provideReasonExt': '延長の理由を入力してください。',
  'fin.tm.t.slaExtended': 'SLAを延長しました',
  'fin.tm.t.slaExtendedDesc': '新しい期限: {deadline}。',
  'fin.tm.t.updated': '更新済み',
  'fin.tm.t.extendFailed': '延長に失敗しました',
  'fin.tm.t.networkError': 'ネットワークエラー',
  'fin.tm.t.missingInfo': '情報が不足しています',
  'fin.tm.t.fillRequired': 'すべての必須項目を入力してください',
  'fin.tm.t.slaRuleSaved': 'SLAルールを保存しました',
  'fin.tm.t.ruleSavedDesc': 'ルール「{name}」をサーバーに保存しました。',
  'fin.tm.t.saveFailed': '保存に失敗しました',
  'fin.tm.t.updateFailed': '更新に失敗しました',
  'fin.tm.t.automationRuleSaved': '自動化ルールを保存しました',
  'fin.tm.t.reportDownloaded': 'レポートをダウンロードしました',
  'fin.tm.t.reportDownloadedDesc': 'ライブデータから{report}レポートを生成しました。',
  'fin.tm.t.reportFailed': 'レポートに失敗しました',
  'fin.tm.t.reasonRequired2': '理由が必要です',
  'fin.tm.t.provideEscReason': 'エスカレーションの理由を入力してください。',
  'fin.tm.t.escalated': 'エスカレーションしました',
  'fin.tm.t.escalatedDesc': 'エスカレーション記録を作成しました。ID: {id}',
  'fin.tm.t.escalationFailed': 'エスカレーションに失敗しました',
  'fin.tm.t.failedEscalate': 'エスカレーションできませんでした。',
  'fin.tm.t.noteRequired': 'メモが必要です',
  'fin.tm.t.enterNote': '保存する前にメモを入力してください。',
  'fin.tm.t.noteAdded': 'メモを追加しました',
  'fin.tm.t.noteAddedDesc': '会話 {conv} にメモを保存しました。',
  'fin.tm.t.failedAddNote': 'メモの追加に失敗しました',
  'fin.tm.t.failedSaveNote': 'メモを保存できませんでした。',
  'fin.tm.t.priorityUpdated': '優先度を更新しました',
  'fin.tm.t.priorityUpdatedDesc': 'チケット {ticket} の優先度を{priority}に設定しました。',
  'fin.tm.t.priorityUpdateFailed': '優先度の更新に失敗しました',
  'fin.tm.t.resolutionRequired': '解決策が必要です',
  'fin.tm.t.provideResolution': '解決の概要を入力してください。',
  'fin.tm.t.ticketResolved': 'チケットを解決しました',
  'fin.tm.t.ticketResolvedDesc': 'チケット {ticket} を解決して保存しました。',
  'fin.tm.t.solutionSubmitted': ' 解決策を承認のために送信しました（ID: {id}）。',
  'fin.tm.t.resolutionFailed': '解決に失敗しました',
  'fin.tm.t.failedResolve': 'チケットを解決できませんでした。',
  'fin.tm.t.ticketReopened': 'チケットを再開しました',
  'fin.tm.t.ticketReopenedDesc': 'チケット {ticket} は再開され、キューに戻されました。',
  'fin.tm.t.reopenFailed': '再開に失敗しました',
  'fin.tm.t.failedReopen': 'チケットを再開できませんでした。',
  'fin.tm.t.assigned': '割り当て済み',
  'fin.tm.t.assignedDesc': 'チケット {ticket} をスタッフ {staff} に割り当てました。',
  'fin.tm.t.assignmentFailed': '割り当てに失敗しました',
  'fin.tm.t.noConversation': '会話がありません',
  'fin.tm.t.cannotSend': '送信できません: このチケットにリンクされた会話がありません。',
  'fin.tm.t.messageSent': 'メッセージを送信しました',
  'fin.tm.t.messageSentDesc': '顧客はこのメッセージを受け取ります。',
  'fin.tm.t.sendFailed': '送信に失敗しました',
  'fin.tm.t.failedSend': 'メッセージを送信できませんでした。',
  'fin.sm.businessName': '会社名',
  'fin.sm.description': '説明',
  'fin.sm.address': '住所',
  'fin.ov.aiVoicePerf': 'AI音声エージェントのパフォーマンス',
  'fin.mo.refreshMetrics': '指標を更新',
  'fin.mf.noRatings': 'まだ評価がありません',
  'fin.mf.marketplaceError': 'マーケットプレイスのエラー:',
  'fin.mf.somethingWrong': '問題が発生しました。もう一度お試しください。',
  'fin.mf.enterLocation': '場所を入力',
  'fin.mf.includesVideo': '動画あり',
  'fin.mf.viewDetails': '詳細を表示',
  'fin.preview.publicProfilePreview': '公開プロフィールのプレビュー',
  'fin.preview.showroomFallback': 'ショールーム',
  'fin.preview.businessShowroom': '企業ショールーム',
  'fin.preview.businessId': '企業ID:',
  'fin.preview.about': '概要',
  'fin.preview.noDescription': '説明はありません',
  'fin.preview.contactInfo': '連絡先情報',
  'fin.preview.email': 'メール:',
  'fin.preview.phone': '電話:',
  'fin.preview.location': '所在地:',
  'fin.preview.notProvided': '未提供',
  'fin.preview.chatAvailable': 'チャット利用可能:',
  'fin.preview.inAppCalls': 'アプリ内通話:',
  'fin.preview.productsServices': '製品とサービス',
  'fin.preview.items': '件',
  'fin.preview.price': '価格:',
  'fin.preview.category': 'カテゴリ:',
  'fin.preview.noImages': '画像なし',
  'fin.preview.noProducts': '現在利用可能な製品はありません。',
  'fin.preview.productsWillAppear': '製品をショールームに追加すると、ここに表示されます。',
  'fin.preview.footer': 'これは、顧客に表示される公開ショールームプロフィールのプレビューです。',
};
const ko = {
  'fin.common.quickActions': '빠른 작업',
  'fin.tm.slaRules': 'SLA 규칙',
  'fin.tm.automation': '자동화',
  'fin.tm.reports': '보고서',
  'fin.tm.slaRulesMgmt': 'SLA 규칙 관리',
  'fin.tm.slaRulesMgmtDesc': '서비스 수준 계약 규칙 및 에스컬레이션 정책을 구성합니다',
  'fin.tm.addSlaRule': '새 SLA 규칙 추가',
  'fin.tm.ruleName': '규칙 이름 *',
  'fin.tm.ruleNamePh1': '예: 높은 우선순위 응답',
  'fin.tm.priorityLevel': '우선순위 수준',
  'fin.opt.low': '낮음',
  'fin.opt.medium': '중간',
  'fin.opt.high': '높음',
  'fin.opt.critical': '심각',
  'fin.tm.condition': '조건 *',
  'fin.tm.conditionPh': '예: 우선순위 = 높음 그리고 고객 유형 = VIP',
  'fin.tm.action': '작업 *',
  'fin.tm.actionPh': '예: 1시간 이내에 응답하고 관리자에게 에스컬레이션',
  'fin.tm.addSlaRuleBtn': 'SLA 규칙 추가',
  'fin.tm.activeSlaRules': '활성 SLA 규칙',
  'fin.tm.active': '활성',
  'fin.tm.inactive': '비활성',
  'fin.tm.when': '조건:',
  'fin.tm.then': '실행:',
  'fin.tm.disable': '비활성화',
  'fin.tm.enable': '활성화',
  'fin.tm.automationRules': '자동화 규칙',
  'fin.tm.automationRulesDesc': '티켓 처리 및 워크플로를 위한 자동화 작업을 구성합니다',
  'fin.tm.addAutomationRule': '새 자동화 규칙 추가',
  'fin.tm.autoRuleNamePh': '예: 기술 문제 자동 할당',
  'fin.tm.triggerCondition': '트리거 조건 *',
  'fin.tm.triggerConditionPh': '예: 카테고리 = 기술 그리고 우선순위 = 높음',
  'fin.tm.automatedAction': '자동화 작업 *',
  'fin.tm.automatedActionPh': '예: 기술팀에 할당하고 확인 이메일 전송',
  'fin.tm.addAutomationRuleBtn': '자동화 규칙 추가',
  'fin.tm.activeAutomationRules': '활성 자동화 규칙',
  'fin.tm.trigger': '트리거:',
  'fin.tm.actionLabel': '작업:',
  'fin.tm.reportsTitle': '티켓 관리 보고서',
  'fin.tm.reportsDesc': '티켓 분석 및 성과 추적을 위한 종합 보고서를 생성합니다',
  'fin.tm.rptSlaPerf': 'SLA 성과',
  'fin.tm.rptSlaPerfSub': '응답 시간 및 위반',
  'fin.tm.rptAgentPerf': '상담원 성과',
  'fin.tm.rptAgentPerfSub': '해결률 및 KPI',
  'fin.tm.rptAutoEff': '자동화 효율성',
  'fin.tm.rptAutoEffSub': '규칙 성과',
  'fin.tm.rptCsat': '고객 만족도',
  'fin.tm.rptCsatSub': 'CSAT 및 피드백',
  'fin.tm.totalTickets': '전체 티켓',
  'fin.tm.highPriority': '높은 우선순위',
  'fin.tm.slaAtRisk': 'SLA 위험',
  'fin.tm.unassigned': '미할당',
  'fin.tm.resolvedToday': '오늘 해결됨',
  'fin.tm.searchPh': '티켓 검색...',
  'fin.tm.priority': '우선순위',
  'fin.tm.allPriority': '모든 우선순위',
  'fin.tm.status': '상태',
  'fin.tm.allStatus': '모든 상태',
  'fin.tm.resolved': '해결됨',
  'fin.tm.inProgress': '진행 중',
  'fin.tm.pending': '대기 중',
  'fin.tm.assignee': '담당자',
  'fin.tm.allAssignees': '모든 담당자',
  'fin.tm.apply': '적용',
  'fin.tm.applyTitle': '최신 티켓에 필터를 다시 적용',
  'fin.tm.sortTitle': '생성 날짜별 정렬 전환',
  'fin.tm.ticketsCount': '티켓 ({count})',
  'fin.tm.newest': '최신순',
  'fin.tm.oldest': '오래된순',
  'fin.tm.loadErr': '티켓을 불러오지 못했습니다:',
  'fin.tm.noMatch': '현재 필터와 일치하는 티켓이 없습니다.',
  'fin.tm.assignedTo': '담당:',
  'fin.tm.ticketDetails': '티켓 세부 정보',
  'fin.tm.customerInfo': '고객 정보',
  'fin.tm.name': '이름:',
  'fin.tm.tier': '등급:',
  'fin.tm.notConfigured': '구성되지 않음',
  'fin.tm.previousTickets': '이전 티켓:',
  'fin.tm.totalTicketsLbl': '전체 티켓:',
  'fin.tm.satisfaction': '만족도:',
  'fin.tm.lastTicket': '마지막 티켓:',
  'fin.tm.slaManagement': 'SLA 관리',
  'fin.tm.statusLbl': '상태:',
  'fin.tm.timeRemaining': '남은 시간:',
  'fin.tm.deadlineLbl': '마감일:',
  'fin.tm.noSlaConfigured': '이 티켓에 구성된 SLA가 없습니다. 마감일을 활성화하려면 우선순위에 맞는 SLA 규칙을 추가하세요.',
  'fin.tm.extendSla': 'SLA 연장',
  'fin.tm.assignment': '할당',
  'fin.tm.escalationHistory': '에스컬레이션 기록',
  'fin.tm.level': '수준',
  'fin.tm.escalateToManager': '관리자에게 에스컬레이션',
  'fin.tm.escalateTicket': '티켓 에스컬레이션',
  'fin.tm.escalateDesc': '티켓 #{id}을(를) 관리자에게 에스컬레이션합니다',
  'fin.tm.selectManager': '관리자 선택 *',
  'fin.tm.selectManagerPh': '관리자 선택',
  'fin.tm.noManagers': '관리자를 찾을 수 없습니다',
  'fin.tm.urgencyLevel': '긴급도 수준',
  'fin.tm.urgLow': '낮음 - 표준 에스컬레이션',
  'fin.tm.urgNormal': '보통 - 주의 필요',
  'fin.tm.urgHigh': '높음 - 긴급 에스컬레이션',
  'fin.tm.urgCritical': '심각 - 즉시 대응',
  'fin.tm.escalationReason': '에스컬레이션 사유 *',
  'fin.tm.escalationReasonPh': '이 티켓을 관리자에게 에스컬레이션해야 하는 이유를 설명하세요...',
  'fin.tm.addInternalNote': '내부 메모 추가',
  'fin.tm.addNoteDesc': '티켓 #{id}에 내부 메모를 추가합니다',
  'fin.tm.noteVisibility': '메모 공개 범위',
  'fin.tm.visInternal': '내부 전용 - 직원이 볼 수 있음',
  'fin.tm.visCustomer': '고객에게 표시 - 업데이트에 포함',
  'fin.tm.noteContent': '메모 내용 *',
  'fin.tm.noteContentPh': '여기에 메모를 입력하세요...',
  'fin.tm.addNote': '메모 추가',
  'fin.tm.setPriority': '우선순위 설정',
  'fin.tm.setTicketPriority': '티켓 우선순위 설정',
  'fin.tm.setPriorityDesc': '티켓 #{id}의 우선순위를 업데이트합니다',
  'fin.tm.prioLow': '낮음 - 긴급하지 않은 문제',
  'fin.tm.prioMedium': '중간 - 표준 우선순위',
  'fin.tm.prioHigh': '높음 - 중요한 문제',
  'fin.tm.prioUrgent': '긴급 - 심각한 문제',
  'fin.tm.reasonForChange': '변경 사유 (선택 사항)',
  'fin.tm.reasonForChangePh': '우선순위를 변경하는 이유를 설명하세요...',
  'fin.tm.updatePriority': '우선순위 업데이트',
  'fin.tm.reopenTicket': '티켓 재개',
  'fin.tm.reopenPrompt': '재개 사유 (선택 사항):',
  'fin.tm.markResolved': '해결됨으로 표시',
  'fin.tm.escalate': '에스컬레이션',
  'fin.tm.resolutionStepsRequired': '의미 있는 해결 단계를 입력하세요(비어 있음·자리표시자·콜백 시간·전달은 불가). 티켓 해결에 필수입니다.',
  'fin.tm.resolutionStepsGovTitle': '해결 지식 (필수)',
  'fin.tm.resolutionStepsLabel': '해결 단계 (필수)',
  'fin.tm.solutionSubmittedNote': '해결책을 솔루션 뱅크에 제출했습니다(관리자 검토 대기).',
  'fin.tm.myQueue': '내 대기열',
  'fin.tm.escalatedBadge': '에스컬레이션됨',
  'fin.tm.selectOperator': '오퍼레이터에게 배정',
  'fin.tm.selectOperatorPh': '사용 가능한 오퍼레이터 선택',
  'fin.tm.noOperators': '사용 가능한 오퍼레이터가 없습니다',
  'fin.tm.assigneeRequired': '배정할 오퍼레이터를 선택하세요',
  'fin.tm.knowledgeGovernanceHint': '재사용 가능한 해결책에는 구체적인 단계가 필요하며 AI 재사용 전에 관리자가 검토합니다.',
  'fin.tm.resolveTicket': '티켓 해결',
  'fin.tm.resolveDesc': '티켓 #{id}을(를) 해결됨으로 표시합니다',
  'fin.tm.resolutionSummary': '해결 요약 *',
  'fin.tm.resolutionSummaryPh': '이 문제가 어떻게 해결되었는지 설명하세요...',
  'fin.tm.notifyCustomer': '해결에 대해 고객에게 알림',
  'fin.tm.submitToBank': '해결책을 솔루션 뱅크에 제출 (승인 대기 중)',
  'fin.tm.extendSlaDesc': '티켓 #{id}의 SLA 마감일을 연장합니다. 이 작업은 귀하의 이름과 사유와 함께 기록됩니다.',
  'fin.tm.duration': '기간 *',
  'fin.tm.durationPh': '예: 4',
  'fin.tm.unit': '단위',
  'fin.tm.hours': '시간',
  'fin.tm.minutes': '분',
  'fin.tm.reason': '사유 *',
  'fin.tm.reasonPh': '이 SLA를 연장하는 이유는 무엇입니까?',
  'fin.tm.extending': '연장 중…',
  'fin.tm.quickResponse': '빠른 응답',
  'fin.tm.quickResponsePh': '고객에게 보낼 메시지를 입력...',
  'fin.tm.sendToCustomer': '고객에게 전송',
  'fin.tm.selectTicket': '티켓 선택',
  'fin.tm.selectTicketDesc': '목록에서 티켓을 선택하여 세부 정보를 보고 할당을 관리하세요',
  'fin.tm.t.invalidDuration': '잘못된 기간',
  'fin.tm.t.enterPositive': '양수를 입력하세요.',
  'fin.tm.t.reasonRequired': '사유가 필요합니다',
  'fin.tm.t.provideReasonExt': '연장 사유를 입력하세요.',
  'fin.tm.t.slaExtended': 'SLA 연장됨',
  'fin.tm.t.slaExtendedDesc': '새 마감일: {deadline}.',
  'fin.tm.t.updated': '업데이트됨',
  'fin.tm.t.extendFailed': '연장 실패',
  'fin.tm.t.networkError': '네트워크 오류',
  'fin.tm.t.missingInfo': '정보 누락',
  'fin.tm.t.fillRequired': '모든 필수 항목을 입력하세요',
  'fin.tm.t.slaRuleSaved': 'SLA 규칙 저장됨',
  'fin.tm.t.ruleSavedDesc': '규칙 "{name}"이(가) 서버에 저장되었습니다.',
  'fin.tm.t.saveFailed': '저장 실패',
  'fin.tm.t.updateFailed': '업데이트 실패',
  'fin.tm.t.automationRuleSaved': '자동화 규칙 저장됨',
  'fin.tm.t.reportDownloaded': '보고서 다운로드됨',
  'fin.tm.t.reportDownloadedDesc': '실시간 데이터에서 {report} 보고서를 생성했습니다.',
  'fin.tm.t.reportFailed': '보고서 실패',
  'fin.tm.t.reasonRequired2': '사유 필요',
  'fin.tm.t.provideEscReason': '에스컬레이션 사유를 입력하세요.',
  'fin.tm.t.escalated': '에스컬레이션됨',
  'fin.tm.t.escalatedDesc': '에스컬레이션 기록이 생성되었습니다. ID: {id}',
  'fin.tm.t.escalationFailed': '에스컬레이션 실패',
  'fin.tm.t.failedEscalate': '에스컬레이션하지 못했습니다.',
  'fin.tm.t.noteRequired': '메모 필요',
  'fin.tm.t.enterNote': '저장하기 전에 메모를 입력하세요.',
  'fin.tm.t.noteAdded': '메모 추가됨',
  'fin.tm.t.noteAddedDesc': '대화 {conv}에 메모가 저장되었습니다.',
  'fin.tm.t.failedAddNote': '메모 추가 실패',
  'fin.tm.t.failedSaveNote': '메모를 저장하지 못했습니다.',
  'fin.tm.t.priorityUpdated': '우선순위 업데이트됨',
  'fin.tm.t.priorityUpdatedDesc': '티켓 {ticket}의 우선순위가 {priority}(으)로 설정되었습니다.',
  'fin.tm.t.priorityUpdateFailed': '우선순위 업데이트 실패',
  'fin.tm.t.resolutionRequired': '해결책 필요',
  'fin.tm.t.provideResolution': '해결 요약을 입력하세요.',
  'fin.tm.t.ticketResolved': '티켓 해결됨',
  'fin.tm.t.ticketResolvedDesc': '티켓 {ticket}이(가) 해결되어 저장되었습니다.',
  'fin.tm.t.solutionSubmitted': ' 해결책이 승인을 위해 제출되었습니다 (ID: {id}).',
  'fin.tm.t.resolutionFailed': '해결 실패',
  'fin.tm.t.failedResolve': '티켓을 해결하지 못했습니다.',
  'fin.tm.t.ticketReopened': '티켓 재개됨',
  'fin.tm.t.ticketReopenedDesc': '티켓 {ticket}이(가) 재개되어 대기열로 반환되었습니다.',
  'fin.tm.t.reopenFailed': '재개 실패',
  'fin.tm.t.failedReopen': '티켓을 재개하지 못했습니다.',
  'fin.tm.t.assigned': '할당됨',
  'fin.tm.t.assignedDesc': '티켓 {ticket}이(가) 직원 {staff}에게 할당되었습니다.',
  'fin.tm.t.assignmentFailed': '할당 실패',
  'fin.tm.t.noConversation': '대화 없음',
  'fin.tm.t.cannotSend': '전송할 수 없습니다: 이 티켓에 연결된 대화가 없습니다.',
  'fin.tm.t.messageSent': '메시지 전송됨',
  'fin.tm.t.messageSentDesc': '고객이 이 메시지를 받게 됩니다.',
  'fin.tm.t.sendFailed': '전송 실패',
  'fin.tm.t.failedSend': '메시지를 전송하지 못했습니다.',
  'fin.sm.businessName': '업체명',
  'fin.sm.description': '설명',
  'fin.sm.address': '주소',
  'fin.ov.aiVoicePerf': 'AI 음성 상담원 성과',
  'fin.mo.refreshMetrics': '지표 새로고침',
  'fin.mf.noRatings': '아직 평가가 없습니다',
  'fin.mf.marketplaceError': '마켓플레이스 오류:',
  'fin.mf.somethingWrong': '문제가 발생했습니다. 다시 시도하세요.',
  'fin.mf.enterLocation': '위치 입력',
  'fin.mf.includesVideo': '동영상 포함',
  'fin.mf.viewDetails': '세부 정보 보기',
  'fin.preview.publicProfilePreview': '공개 프로필 미리보기',
  'fin.preview.showroomFallback': '쇼룸',
  'fin.preview.businessShowroom': '업체 쇼룸',
  'fin.preview.businessId': '업체 ID:',
  'fin.preview.about': '소개',
  'fin.preview.noDescription': '설명이 없습니다',
  'fin.preview.contactInfo': '연락처 정보',
  'fin.preview.email': '이메일:',
  'fin.preview.phone': '전화:',
  'fin.preview.location': '위치:',
  'fin.preview.notProvided': '제공되지 않음',
  'fin.preview.chatAvailable': '채팅 가능:',
  'fin.preview.inAppCalls': '앱 내 통화:',
  'fin.preview.productsServices': '제품 및 서비스',
  'fin.preview.items': '개',
  'fin.preview.price': '가격:',
  'fin.preview.category': '카테고리:',
  'fin.preview.noImages': '이미지 없음',
  'fin.preview.noProducts': '현재 사용 가능한 제품이 없습니다.',
  'fin.preview.productsWillAppear': '제품을 쇼룸에 추가하면 여기에 표시됩니다.',
  'fin.preview.footer': '이것은 고객에게 표시되는 공개 쇼룸 프로필의 미리보기입니다.',
};
const zh = {
  'fin.common.quickActions': '快捷操作',
  'fin.tm.slaRules': 'SLA 规则',
  'fin.tm.automation': '自动化',
  'fin.tm.reports': '报告',
  'fin.tm.slaRulesMgmt': 'SLA 规则管理',
  'fin.tm.slaRulesMgmtDesc': '配置服务级别协议规则和升级策略',
  'fin.tm.addSlaRule': '添加新的 SLA 规则',
  'fin.tm.ruleName': '规则名称 *',
  'fin.tm.ruleNamePh1': '例如：高优先级响应',
  'fin.tm.priorityLevel': '优先级',
  'fin.opt.low': '低',
  'fin.opt.medium': '中',
  'fin.opt.high': '高',
  'fin.opt.critical': '严重',
  'fin.tm.condition': '条件 *',
  'fin.tm.conditionPh': '例如：优先级 = 高 且 客户类型 = VIP',
  'fin.tm.action': '操作 *',
  'fin.tm.actionPh': '例如：在 1 小时内响应并升级至经理',
  'fin.tm.addSlaRuleBtn': '添加 SLA 规则',
  'fin.tm.activeSlaRules': '活动的 SLA 规则',
  'fin.tm.active': '活动',
  'fin.tm.inactive': '非活动',
  'fin.tm.when': '当：',
  'fin.tm.then': '则：',
  'fin.tm.disable': '禁用',
  'fin.tm.enable': '启用',
  'fin.tm.automationRules': '自动化规则',
  'fin.tm.automationRulesDesc': '配置用于工单处理和工作流的自动化操作',
  'fin.tm.addAutomationRule': '添加新的自动化规则',
  'fin.tm.autoRuleNamePh': '例如：自动分配技术问题',
  'fin.tm.triggerCondition': '触发条件 *',
  'fin.tm.triggerConditionPh': '例如：类别 = 技术 且 优先级 = 高',
  'fin.tm.automatedAction': '自动化操作 *',
  'fin.tm.automatedActionPh': '例如：分配给技术团队并发送确认电子邮件',
  'fin.tm.addAutomationRuleBtn': '添加自动化规则',
  'fin.tm.activeAutomationRules': '活动的自动化规则',
  'fin.tm.trigger': '触发器：',
  'fin.tm.actionLabel': '操作：',
  'fin.tm.reportsTitle': '工单管理报告',
  'fin.tm.reportsDesc': '生成用于工单分析和绩效跟踪的综合报告',
  'fin.tm.rptSlaPerf': 'SLA 绩效',
  'fin.tm.rptSlaPerfSub': '响应时间和违规',
  'fin.tm.rptAgentPerf': '客服绩效',
  'fin.tm.rptAgentPerfSub': '解决率和 KPI',
  'fin.tm.rptAutoEff': '自动化效率',
  'fin.tm.rptAutoEffSub': '规则绩效',
  'fin.tm.rptCsat': '客户满意度',
  'fin.tm.rptCsatSub': 'CSAT 和反馈',
  'fin.tm.totalTickets': '工单总数',
  'fin.tm.highPriority': '高优先级',
  'fin.tm.slaAtRisk': 'SLA 存在风险',
  'fin.tm.unassigned': '未分配',
  'fin.tm.resolvedToday': '今日已解决',
  'fin.tm.searchPh': '搜索工单...',
  'fin.tm.priority': '优先级',
  'fin.tm.allPriority': '所有优先级',
  'fin.tm.status': '状态',
  'fin.tm.allStatus': '所有状态',
  'fin.tm.resolved': '已解决',
  'fin.tm.inProgress': '进行中',
  'fin.tm.pending': '待处理',
  'fin.tm.assignee': '受理人',
  'fin.tm.allAssignees': '所有受理人',
  'fin.tm.apply': '应用',
  'fin.tm.applyTitle': '对最新工单重新应用筛选器',
  'fin.tm.sortTitle': '切换按创建日期排序',
  'fin.tm.ticketsCount': '工单 ({count})',
  'fin.tm.newest': '最新',
  'fin.tm.oldest': '最早',
  'fin.tm.loadErr': '加载工单失败：',
  'fin.tm.noMatch': '没有工单符合当前筛选条件。',
  'fin.tm.assignedTo': '分配给：',
  'fin.tm.ticketDetails': '工单详情',
  'fin.tm.customerInfo': '客户信息',
  'fin.tm.name': '姓名：',
  'fin.tm.tier': '等级：',
  'fin.tm.notConfigured': '未配置',
  'fin.tm.previousTickets': '以往工单：',
  'fin.tm.totalTicketsLbl': '工单总数：',
  'fin.tm.satisfaction': '满意度：',
  'fin.tm.lastTicket': '最近工单：',
  'fin.tm.slaManagement': 'SLA 管理',
  'fin.tm.statusLbl': '状态：',
  'fin.tm.timeRemaining': '剩余时间：',
  'fin.tm.deadlineLbl': '截止时间：',
  'fin.tm.noSlaConfigured': '此工单未配置 SLA。请添加与其优先级匹配的 SLA 规则以启用截止时间。',
  'fin.tm.extendSla': '延长 SLA',
  'fin.tm.assignment': '分配',
  'fin.tm.escalationHistory': '升级历史',
  'fin.tm.level': '级别',
  'fin.tm.escalateToManager': '升级至经理',
  'fin.tm.escalateTicket': '升级工单',
  'fin.tm.escalateDesc': '将工单 #{id} 升级至经理',
  'fin.tm.selectManager': '选择经理 *',
  'fin.tm.selectManagerPh': '选择经理',
  'fin.tm.noManagers': '未找到经理',
  'fin.tm.urgencyLevel': '紧急程度',
  'fin.tm.urgLow': '低 - 标准升级',
  'fin.tm.urgNormal': '普通 - 需要关注',
  'fin.tm.urgHigh': '高 - 紧急升级',
  'fin.tm.urgCritical': '严重 - 立即处理',
  'fin.tm.escalationReason': '升级原因 *',
  'fin.tm.escalationReasonPh': '请说明为什么此工单需要升级至经理...',
  'fin.tm.addInternalNote': '添加内部备注',
  'fin.tm.addNoteDesc': '向工单 #{id} 添加内部备注',
  'fin.tm.noteVisibility': '备注可见性',
  'fin.tm.visInternal': '仅内部 - 员工可见',
  'fin.tm.visCustomer': '客户可见 - 包含在更新中',
  'fin.tm.noteContent': '备注内容 *',
  'fin.tm.noteContentPh': '在此输入您的备注...',
  'fin.tm.addNote': '添加备注',
  'fin.tm.setPriority': '设置优先级',
  'fin.tm.setTicketPriority': '设置工单优先级',
  'fin.tm.setPriorityDesc': '更新工单 #{id} 的优先级',
  'fin.tm.prioLow': '低 - 非紧急问题',
  'fin.tm.prioMedium': '中 - 标准优先级',
  'fin.tm.prioHigh': '高 - 重要问题',
  'fin.tm.prioUrgent': '紧急 - 严重问题',
  'fin.tm.reasonForChange': '更改原因（可选）',
  'fin.tm.reasonForChangePh': '请说明更改优先级的原因...',
  'fin.tm.updatePriority': '更新优先级',
  'fin.tm.reopenTicket': '重新打开工单',
  'fin.tm.reopenPrompt': '重新打开的原因（可选）：',
  'fin.tm.markResolved': '标记为已解决',
  'fin.tm.escalate': '升级',
  'fin.tm.resolutionStepsRequired': '请输入有意义的解决步骤（不能为空、占位符、回拨时间或转接）——这是解决工单的必填项。',
  'fin.tm.resolutionStepsGovTitle': '解决知识（必填）',
  'fin.tm.resolutionStepsLabel': '解决步骤（必填）',
  'fin.tm.solutionSubmittedNote': '解决方案已提交至解决方案库，等待经理/管理员审核。',
  'fin.tm.myQueue': '我的队列',
  'fin.tm.escalatedBadge': '已升级',
  'fin.tm.selectOperator': '分配给操作员',
  'fin.tm.selectOperatorPh': '选择一个可用的操作员',
  'fin.tm.noOperators': '没有可用的操作员',
  'fin.tm.assigneeRequired': '请选择要分配的操作员',
  'fin.tm.knowledgeGovernanceHint': '可复用的解决方案需要具体步骤，并在 AI 复用之前由经理或管理员审核。',
  'fin.tm.resolveTicket': '解决工单',
  'fin.tm.resolveDesc': '将工单 #{id} 标记为已解决',
  'fin.tm.resolutionSummary': '解决方案摘要 *',
  'fin.tm.resolutionSummaryPh': '描述此问题是如何解决的...',
  'fin.tm.notifyCustomer': '通知客户已解决',
  'fin.tm.submitToBank': '将解决方案提交至解决方案库（待审批）',
  'fin.tm.extendSlaDesc': '延长工单 #{id} 的 SLA 截止时间。此操作将记录您的姓名和原因。',
  'fin.tm.duration': '时长 *',
  'fin.tm.durationPh': '例如 4',
  'fin.tm.unit': '单位',
  'fin.tm.hours': '小时',
  'fin.tm.minutes': '分钟',
  'fin.tm.reason': '原因 *',
  'fin.tm.reasonPh': '为什么要延长此 SLA？',
  'fin.tm.extending': '正在延长…',
  'fin.tm.quickResponse': '快速回复',
  'fin.tm.quickResponsePh': '输入发送给客户的消息...',
  'fin.tm.sendToCustomer': '发送给客户',
  'fin.tm.selectTicket': '选择一个工单',
  'fin.tm.selectTicketDesc': '从列表中选择一个工单以查看详情并管理分配',
  'fin.tm.t.invalidDuration': '时长无效',
  'fin.tm.t.enterPositive': '请输入一个正数。',
  'fin.tm.t.reasonRequired': '需要原因',
  'fin.tm.t.provideReasonExt': '请提供延长的原因。',
  'fin.tm.t.slaExtended': 'SLA 已延长',
  'fin.tm.t.slaExtendedDesc': '新截止时间：{deadline}。',
  'fin.tm.t.updated': '已更新',
  'fin.tm.t.extendFailed': '延长失败',
  'fin.tm.t.networkError': '网络错误',
  'fin.tm.t.missingInfo': '信息缺失',
  'fin.tm.t.fillRequired': '请填写所有必填字段',
  'fin.tm.t.slaRuleSaved': 'SLA 规则已保存',
  'fin.tm.t.ruleSavedDesc': '规则“{name}”已保存到服务器。',
  'fin.tm.t.saveFailed': '保存失败',
  'fin.tm.t.updateFailed': '更新失败',
  'fin.tm.t.automationRuleSaved': '自动化规则已保存',
  'fin.tm.t.reportDownloaded': '报告已下载',
  'fin.tm.t.reportDownloadedDesc': '已根据实时数据生成 {report} 报告。',
  'fin.tm.t.reportFailed': '报告失败',
  'fin.tm.t.reasonRequired2': '需要原因',
  'fin.tm.t.provideEscReason': '请提供升级的原因。',
  'fin.tm.t.escalated': '已升级',
  'fin.tm.t.escalatedDesc': '已创建升级记录。ID：{id}',
  'fin.tm.t.escalationFailed': '升级失败',
  'fin.tm.t.failedEscalate': '升级失败。',
  'fin.tm.t.noteRequired': '需要备注',
  'fin.tm.t.enterNote': '请在保存前输入备注。',
  'fin.tm.t.noteAdded': '备注已添加',
  'fin.tm.t.noteAddedDesc': '备注已保存到对话 {conv}。',
  'fin.tm.t.failedAddNote': '添加备注失败',
  'fin.tm.t.failedSaveNote': '保存备注失败。',
  'fin.tm.t.priorityUpdated': '优先级已更新',
  'fin.tm.t.priorityUpdatedDesc': '工单 {ticket} 的优先级已设置为 {priority}。',
  'fin.tm.t.priorityUpdateFailed': '优先级更新失败',
  'fin.tm.t.resolutionRequired': '需要解决方案',
  'fin.tm.t.provideResolution': '请提供解决方案摘要。',
  'fin.tm.t.ticketResolved': '工单已解决',
  'fin.tm.t.ticketResolvedDesc': '工单 {ticket} 已解决并保存。',
  'fin.tm.t.solutionSubmitted': ' 解决方案已提交审批（ID：{id}）。',
  'fin.tm.t.resolutionFailed': '解决失败',
  'fin.tm.t.failedResolve': '无法解决工单。',
  'fin.tm.t.ticketReopened': '工单已重新打开',
  'fin.tm.t.ticketReopenedDesc': '工单 {ticket} 已重新打开并返回队列。',
  'fin.tm.t.reopenFailed': '重新打开失败',
  'fin.tm.t.failedReopen': '无法重新打开工单。',
  'fin.tm.t.assigned': '已分配',
  'fin.tm.t.assignedDesc': '工单 {ticket} 已分配给员工 {staff}。',
  'fin.tm.t.assignmentFailed': '分配失败',
  'fin.tm.t.noConversation': '无对话',
  'fin.tm.t.cannotSend': '无法发送：没有与此工单关联的对话。',
  'fin.tm.t.messageSent': '消息已发送',
  'fin.tm.t.messageSentDesc': '客户将收到此消息。',
  'fin.tm.t.sendFailed': '发送失败',
  'fin.tm.t.failedSend': '无法发送消息。',
  'fin.sm.businessName': '企业名称',
  'fin.sm.description': '描述',
  'fin.sm.address': '地址',
  'fin.ov.aiVoicePerf': 'AI 语音客服绩效',
  'fin.mo.refreshMetrics': '刷新指标',
  'fin.mf.noRatings': '暂无评分',
  'fin.mf.marketplaceError': '市场错误：',
  'fin.mf.somethingWrong': '出现问题。请重试。',
  'fin.mf.enterLocation': '输入位置',
  'fin.mf.includesVideo': '包含视频',
  'fin.mf.viewDetails': '查看详情',
  'fin.preview.publicProfilePreview': '公开资料预览',
  'fin.preview.showroomFallback': '展厅',
  'fin.preview.businessShowroom': '企业展厅',
  'fin.preview.businessId': '企业 ID：',
  'fin.preview.about': '关于',
  'fin.preview.noDescription': '暂无描述',
  'fin.preview.contactInfo': '联系信息',
  'fin.preview.email': '电子邮件：',
  'fin.preview.phone': '电话：',
  'fin.preview.location': '位置：',
  'fin.preview.notProvided': '未提供',
  'fin.preview.chatAvailable': '可聊天：',
  'fin.preview.inAppCalls': '应用内通话：',
  'fin.preview.productsServices': '产品和服务',
  'fin.preview.items': '项',
  'fin.preview.price': '价格：',
  'fin.preview.category': '类别：',
  'fin.preview.noImages': '无图片',
  'fin.preview.noProducts': '目前没有可用的产品。',
  'fin.preview.productsWillAppear': '将产品添加到展厅后，它们将显示在此处。',
  'fin.preview.footer': '这是您公开展厅资料的预览，即客户将看到的样子。',
};
const ar = {
  'fin.common.quickActions': 'إجراءات سريعة',
  'fin.tm.slaRules': 'قواعد اتفاقية مستوى الخدمة',
  'fin.tm.automation': 'الأتمتة',
  'fin.tm.reports': 'التقارير',
  'fin.tm.slaRulesMgmt': 'إدارة قواعد اتفاقية مستوى الخدمة',
  'fin.tm.slaRulesMgmtDesc': 'قم بتكوين قواعد اتفاقية مستوى الخدمة وسياسات التصعيد',
  'fin.tm.addSlaRule': 'إضافة قاعدة SLA جديدة',
  'fin.tm.ruleName': 'اسم القاعدة *',
  'fin.tm.ruleNamePh1': 'مثال: استجابة ذات أولوية عالية',
  'fin.tm.priorityLevel': 'مستوى الأولوية',
  'fin.opt.low': 'منخفضة',
  'fin.opt.medium': 'متوسطة',
  'fin.opt.high': 'عالية',
  'fin.opt.critical': 'حرجة',
  'fin.tm.condition': 'الشرط *',
  'fin.tm.conditionPh': 'مثال: الأولوية = عالية و نوع العميل = VIP',
  'fin.tm.action': 'الإجراء *',
  'fin.tm.actionPh': 'مثال: الرد خلال ساعة واحدة والتصعيد إلى المدير',
  'fin.tm.addSlaRuleBtn': 'إضافة قاعدة SLA',
  'fin.tm.activeSlaRules': 'قواعد SLA النشطة',
  'fin.tm.active': 'نشطة',
  'fin.tm.inactive': 'غير نشطة',
  'fin.tm.when': 'عندما:',
  'fin.tm.then': 'إذن:',
  'fin.tm.disable': 'تعطيل',
  'fin.tm.enable': 'تفعيل',
  'fin.tm.automationRules': 'قواعد الأتمتة',
  'fin.tm.automationRulesDesc': 'قم بتكوين الإجراءات الآلية لمعالجة التذاكر وسير العمل',
  'fin.tm.addAutomationRule': 'إضافة قاعدة أتمتة جديدة',
  'fin.tm.autoRuleNamePh': 'مثال: تعيين المشكلات التقنية تلقائيًا',
  'fin.tm.triggerCondition': 'شرط التشغيل *',
  'fin.tm.triggerConditionPh': 'مثال: الفئة = تقنية و الأولوية = عالية',
  'fin.tm.automatedAction': 'إجراء آلي *',
  'fin.tm.automatedActionPh': 'مثال: التعيين إلى الفريق التقني وإرسال بريد إلكتروني للتأكيد',
  'fin.tm.addAutomationRuleBtn': 'إضافة قاعدة أتمتة',
  'fin.tm.activeAutomationRules': 'قواعد الأتمتة النشطة',
  'fin.tm.trigger': 'المُشغِّل:',
  'fin.tm.actionLabel': 'الإجراء:',
  'fin.tm.reportsTitle': 'تقارير إدارة التذاكر',
  'fin.tm.reportsDesc': 'أنشئ تقارير شاملة لتحليل التذاكر وتتبع الأداء',
  'fin.tm.rptSlaPerf': 'أداء SLA',
  'fin.tm.rptSlaPerfSub': 'أوقات الاستجابة والانتهاكات',
  'fin.tm.rptAgentPerf': 'أداء الوكيل',
  'fin.tm.rptAgentPerfSub': 'معدلات الحل ومؤشرات الأداء',
  'fin.tm.rptAutoEff': 'كفاءة الأتمتة',
  'fin.tm.rptAutoEffSub': 'أداء القواعد',
  'fin.tm.rptCsat': 'رضا العملاء',
  'fin.tm.rptCsatSub': 'CSAT والملاحظات',
  'fin.tm.totalTickets': 'إجمالي التذاكر',
  'fin.tm.highPriority': 'أولوية عالية',
  'fin.tm.slaAtRisk': 'SLA في خطر',
  'fin.tm.unassigned': 'غير معيَّنة',
  'fin.tm.resolvedToday': 'تم حلها اليوم',
  'fin.tm.searchPh': 'البحث عن التذاكر...',
  'fin.tm.priority': 'الأولوية',
  'fin.tm.allPriority': 'كل الأولويات',
  'fin.tm.status': 'الحالة',
  'fin.tm.allStatus': 'كل الحالات',
  'fin.tm.resolved': 'تم الحل',
  'fin.tm.inProgress': 'قيد التنفيذ',
  'fin.tm.pending': 'معلقة',
  'fin.tm.assignee': 'المُعيَّن إليه',
  'fin.tm.allAssignees': 'كل المُعيَّنين',
  'fin.tm.apply': 'تطبيق',
  'fin.tm.applyTitle': 'إعادة تطبيق عوامل التصفية على أحدث التذاكر',
  'fin.tm.sortTitle': 'تبديل الترتيب حسب تاريخ الإنشاء',
  'fin.tm.ticketsCount': 'التذاكر ({count})',
  'fin.tm.newest': 'الأحدث',
  'fin.tm.oldest': 'الأقدم',
  'fin.tm.loadErr': 'فشل تحميل التذاكر:',
  'fin.tm.noMatch': 'لا توجد تذاكر تطابق عوامل التصفية الحالية.',
  'fin.tm.assignedTo': 'معيَّنة إلى:',
  'fin.tm.ticketDetails': 'تفاصيل التذكرة',
  'fin.tm.customerInfo': 'معلومات العميل',
  'fin.tm.name': 'الاسم:',
  'fin.tm.tier': 'المستوى:',
  'fin.tm.notConfigured': 'غير مُكوَّن',
  'fin.tm.previousTickets': 'التذاكر السابقة:',
  'fin.tm.totalTicketsLbl': 'إجمالي التذاكر:',
  'fin.tm.satisfaction': 'الرضا:',
  'fin.tm.lastTicket': 'آخر تذكرة:',
  'fin.tm.slaManagement': 'إدارة SLA',
  'fin.tm.statusLbl': 'الحالة:',
  'fin.tm.timeRemaining': 'الوقت المتبقي:',
  'fin.tm.deadlineLbl': 'الموعد النهائي:',
  'fin.tm.noSlaConfigured': 'لا توجد اتفاقية مستوى خدمة مُكوَّنة لهذه التذكرة. أضف قاعدة SLA (مطابقة لأولويتها) لتفعيل موعد نهائي.',
  'fin.tm.extendSla': 'تمديد SLA',
  'fin.tm.assignment': 'التعيين',
  'fin.tm.escalationHistory': 'سجل التصعيد',
  'fin.tm.level': 'المستوى',
  'fin.tm.escalateToManager': 'التصعيد إلى المدير',
  'fin.tm.escalateTicket': 'تصعيد التذكرة',
  'fin.tm.escalateDesc': 'تصعيد التذكرة رقم {id} إلى مدير',
  'fin.tm.selectManager': 'اختر مديرًا *',
  'fin.tm.selectManagerPh': 'اختر مديرًا',
  'fin.tm.noManagers': 'لم يتم العثور على مديرين',
  'fin.tm.urgencyLevel': 'مستوى الإلحاح',
  'fin.tm.urgLow': 'منخفض - تصعيد قياسي',
  'fin.tm.urgNormal': 'عادي - يتطلب الاهتمام',
  'fin.tm.urgHigh': 'عالٍ - تصعيد عاجل',
  'fin.tm.urgCritical': 'حرج - اهتمام فوري',
  'fin.tm.escalationReason': 'سبب التصعيد *',
  'fin.tm.escalationReasonPh': 'اشرح سبب حاجة هذه التذكرة إلى التصعيد إلى المدير...',
  'fin.tm.addInternalNote': 'إضافة ملاحظة داخلية',
  'fin.tm.addNoteDesc': 'إضافة ملاحظة داخلية إلى التذكرة رقم {id}',
  'fin.tm.noteVisibility': 'إمكانية رؤية الملاحظة',
  'fin.tm.visInternal': 'داخلي فقط - يمكن للموظفين رؤيتها',
  'fin.tm.visCustomer': 'مرئي للعميل - تضمين في التحديثات',
  'fin.tm.noteContent': 'محتوى الملاحظة *',
  'fin.tm.noteContentPh': 'أدخل ملاحظتك هنا...',
  'fin.tm.addNote': 'إضافة ملاحظة',
  'fin.tm.setPriority': 'تعيين الأولوية',
  'fin.tm.setTicketPriority': 'تعيين أولوية التذكرة',
  'fin.tm.setPriorityDesc': 'تحديث أولوية التذكرة رقم {id}',
  'fin.tm.prioLow': 'منخفضة - مشكلة غير عاجلة',
  'fin.tm.prioMedium': 'متوسطة - أولوية قياسية',
  'fin.tm.prioHigh': 'عالية - مشكلة مهمة',
  'fin.tm.prioUrgent': 'عاجلة - مشكلة حرجة',
  'fin.tm.reasonForChange': 'سبب التغيير (اختياري)',
  'fin.tm.reasonForChangePh': 'اشرح سبب تغيير الأولوية...',
  'fin.tm.updatePriority': 'تحديث الأولوية',
  'fin.tm.reopenTicket': 'إعادة فتح التذكرة',
  'fin.tm.reopenPrompt': 'سبب إعادة الفتح (اختياري):',
  'fin.tm.markResolved': 'وضع علامة كمحلولة',
  'fin.tm.escalate': 'تصعيد',
  'fin.tm.resolutionStepsRequired': 'أدخل خطوات حل ذات معنى (ليست فارغة أو نائبة أو وقت معاودة اتصال أو تحويل) — فهي مطلوبة لحل التذكرة.',
  'fin.tm.resolutionStepsGovTitle': 'معرفة الحل (مطلوبة)',
  'fin.tm.resolutionStepsLabel': 'خطوات الحل (مطلوبة)',
  'fin.tm.solutionSubmittedNote': 'تم إرسال الحل إلى بنك الحلول لمراجعة المدير/المسؤول.',
  'fin.tm.myQueue': 'قائمتي',
  'fin.tm.escalatedBadge': 'مُصعَّد',
  'fin.tm.selectOperator': 'تعيين إلى مشغّل',
  'fin.tm.selectOperatorPh': 'اختر مشغّلًا متاحًا',
  'fin.tm.noOperators': 'لا يوجد مشغّلون متاحون',
  'fin.tm.assigneeRequired': 'اختر مشغّلًا للتعيين',
  'fin.tm.knowledgeGovernanceHint': 'تتطلب الحلول القابلة لإعادة الاستخدام خطوات ذات معنى وتتم مراجعتها من قبل مدير أو مسؤول قبل إعادة استخدامها بواسطة الذكاء الاصطناعي.',
  'fin.tm.resolveTicket': 'حل التذكرة',
  'fin.tm.resolveDesc': 'وضع علامة على التذكرة رقم {id} كمحلولة',
  'fin.tm.resolutionSummary': 'ملخص الحل *',
  'fin.tm.resolutionSummaryPh': 'صِف كيف تم حل هذه المشكلة...',
  'fin.tm.notifyCustomer': 'إبلاغ العميل بالحل',
  'fin.tm.submitToBank': 'إرسال الحل إلى بنك الحلول (في انتظار الموافقة)',
  'fin.tm.extendSlaDesc': 'تمديد الموعد النهائي لاتفاقية مستوى الخدمة للتذكرة رقم {id}. يتم تسجيل ذلك باسمك وسببك.',
  'fin.tm.duration': 'المدة *',
  'fin.tm.durationPh': 'مثال: 4',
  'fin.tm.unit': 'الوحدة',
  'fin.tm.hours': 'ساعات',
  'fin.tm.minutes': 'دقائق',
  'fin.tm.reason': 'السبب *',
  'fin.tm.reasonPh': 'لماذا يتم تمديد اتفاقية مستوى الخدمة هذه؟',
  'fin.tm.extending': 'جارٍ التمديد…',
  'fin.tm.quickResponse': 'رد سريع',
  'fin.tm.quickResponsePh': 'اكتب رسالة إلى العميل...',
  'fin.tm.sendToCustomer': 'إرسال إلى العميل',
  'fin.tm.selectTicket': 'اختر تذكرة',
  'fin.tm.selectTicketDesc': 'اختر تذكرة من القائمة لعرض التفاصيل وإدارة التعيين',
  'fin.tm.t.invalidDuration': 'مدة غير صالحة',
  'fin.tm.t.enterPositive': 'أدخل رقمًا موجبًا.',
  'fin.tm.t.reasonRequired': 'السبب مطلوب',
  'fin.tm.t.provideReasonExt': 'يرجى تقديم سبب للتمديد.',
  'fin.tm.t.slaExtended': 'تم تمديد SLA',
  'fin.tm.t.slaExtendedDesc': 'الموعد النهائي الجديد: {deadline}.',
  'fin.tm.t.updated': 'محدَّث',
  'fin.tm.t.extendFailed': 'فشل التمديد',
  'fin.tm.t.networkError': 'خطأ في الشبكة',
  'fin.tm.t.missingInfo': 'معلومات ناقصة',
  'fin.tm.t.fillRequired': 'يرجى ملء جميع الحقول المطلوبة',
  'fin.tm.t.slaRuleSaved': 'تم حفظ قاعدة SLA',
  'fin.tm.t.ruleSavedDesc': 'تم حفظ القاعدة "{name}" على الخادم.',
  'fin.tm.t.saveFailed': 'فشل الحفظ',
  'fin.tm.t.updateFailed': 'فشل التحديث',
  'fin.tm.t.automationRuleSaved': 'تم حفظ قاعدة الأتمتة',
  'fin.tm.t.reportDownloaded': 'تم تنزيل التقرير',
  'fin.tm.t.reportDownloadedDesc': 'تم إنشاء تقرير {report} من البيانات الحية.',
  'fin.tm.t.reportFailed': 'فشل التقرير',
  'fin.tm.t.reasonRequired2': 'السبب مطلوب',
  'fin.tm.t.provideEscReason': 'يرجى تقديم سبب للتصعيد.',
  'fin.tm.t.escalated': 'تم التصعيد',
  'fin.tm.t.escalatedDesc': 'تم إنشاء سجل تصعيد. المعرف: {id}',
  'fin.tm.t.escalationFailed': 'فشل التصعيد',
  'fin.tm.t.failedEscalate': 'فشل التصعيد.',
  'fin.tm.t.noteRequired': 'الملاحظة مطلوبة',
  'fin.tm.t.enterNote': 'يرجى إدخال ملاحظة قبل الحفظ.',
  'fin.tm.t.noteAdded': 'تمت إضافة الملاحظة',
  'fin.tm.t.noteAddedDesc': 'تم حفظ الملاحظة في المحادثة {conv}.',
  'fin.tm.t.failedAddNote': 'فشل إضافة الملاحظة',
  'fin.tm.t.failedSaveNote': 'فشل حفظ الملاحظة.',
  'fin.tm.t.priorityUpdated': 'تم تحديث الأولوية',
  'fin.tm.t.priorityUpdatedDesc': 'تم تعيين أولوية التذكرة {ticket} إلى {priority}.',
  'fin.tm.t.priorityUpdateFailed': 'فشل تحديث الأولوية',
  'fin.tm.t.resolutionRequired': 'الحل مطلوب',
  'fin.tm.t.provideResolution': 'يرجى تقديم ملخص للحل.',
  'fin.tm.t.ticketResolved': 'تم حل التذكرة',
  'fin.tm.t.ticketResolvedDesc': 'تم حل التذكرة {ticket} وحفظها.',
  'fin.tm.t.solutionSubmitted': ' تم إرسال الحل للموافقة (المعرف: {id}).',
  'fin.tm.t.resolutionFailed': 'فشل الحل',
  'fin.tm.t.failedResolve': 'فشل حل التذكرة.',
  'fin.tm.t.ticketReopened': 'تمت إعادة فتح التذكرة',
  'fin.tm.t.ticketReopenedDesc': 'تمت إعادة فتح التذكرة {ticket} وإعادتها إلى قائمة الانتظار.',
  'fin.tm.t.reopenFailed': 'فشل إعادة الفتح',
  'fin.tm.t.failedReopen': 'فشل إعادة فتح التذكرة.',
  'fin.tm.t.assigned': 'تم التعيين',
  'fin.tm.t.assignedDesc': 'تم تعيين التذكرة {ticket} إلى الموظف {staff}.',
  'fin.tm.t.assignmentFailed': 'فشل التعيين',
  'fin.tm.t.noConversation': 'لا توجد محادثة',
  'fin.tm.t.cannotSend': 'لا يمكن الإرسال: لا توجد محادثة مرتبطة بهذه التذكرة.',
  'fin.tm.t.messageSent': 'تم إرسال الرسالة',
  'fin.tm.t.messageSentDesc': 'سيتلقى العميل هذه الرسالة.',
  'fin.tm.t.sendFailed': 'فشل الإرسال',
  'fin.tm.t.failedSend': 'فشل إرسال الرسالة.',
  'fin.sm.businessName': 'اسم النشاط التجاري',
  'fin.sm.description': 'الوصف',
  'fin.sm.address': 'العنوان',
  'fin.ov.aiVoicePerf': 'أداء وكيل الصوت بالذكاء الاصطناعي',
  'fin.mo.refreshMetrics': 'تحديث المقاييس',
  'fin.mf.noRatings': 'لا توجد تقييمات بعد',
  'fin.mf.marketplaceError': 'خطأ في السوق:',
  'fin.mf.somethingWrong': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',
  'fin.mf.enterLocation': 'أدخل الموقع',
  'fin.mf.includesVideo': 'يتضمن فيديو',
  'fin.mf.viewDetails': 'عرض التفاصيل',
  'fin.preview.publicProfilePreview': 'معاينة الملف الشخصي العام',
  'fin.preview.showroomFallback': 'صالة العرض',
  'fin.preview.businessShowroom': 'صالة عرض النشاط التجاري',
  'fin.preview.businessId': 'معرف النشاط التجاري:',
  'fin.preview.about': 'حول',
  'fin.preview.noDescription': 'لا يوجد وصف متاح',
  'fin.preview.contactInfo': 'معلومات الاتصال',
  'fin.preview.email': 'البريد الإلكتروني:',
  'fin.preview.phone': 'الهاتف:',
  'fin.preview.location': 'الموقع:',
  'fin.preview.notProvided': 'غير مُقدَّم',
  'fin.preview.chatAvailable': 'الدردشة متاحة:',
  'fin.preview.inAppCalls': 'المكالمات داخل التطبيق:',
  'fin.preview.productsServices': 'المنتجات والخدمات',
  'fin.preview.items': 'عناصر',
  'fin.preview.price': 'السعر:',
  'fin.preview.category': 'الفئة:',
  'fin.preview.noImages': 'لا توجد صور',
  'fin.preview.noProducts': 'لا توجد منتجات متاحة في الوقت الحالي.',
  'fin.preview.productsWillAppear': 'ستظهر المنتجات هنا بمجرد إضافتها إلى صالة العرض الخاصة بك.',
  'fin.preview.footer': 'هذه معاينة للملف الشخصي العام لصالة العرض الخاصة بك كما سيظهر للعملاء.',
};

export default { en, es, fr, pt, de, it, ja, ko, zh, ar };
